import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Row, Col, Form, Input, Select, message, DatePicker, Spin, Table, Space, Drawer, Modal, Popover } from 'antd';
import PropTypes from 'prop-types';
import "moment-timezone";
import moment from 'moment';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { PlusCircleOutlined, InfoCircleOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import FeatherIcon from 'feather-icons-react';
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
// import InitialData from './InitialData.json'
import DetailsPage from './DetailsPage/Detailspage';
import DealFields from './DetailsPage/DealDetailsFields'
import RelatedTab from './DetailsPage/RelatedTab'
import DealRightData from './DetailsPage/DealRightData'
import DealStatusBar from './DetailsPage/DealStatusBar'
// import PipelineStagesArrow from './DetailsPage/PipelineStages'
import AddTaskPage from './AddTask'
import { UploadUserTag, UserOwnerDetails } from './GlobalComponents/UserCardCmnts'
import { AccountDetails, DealDetails, TaskRelatedItem, TaskRelatedItem1 } from './GlobalComponents/OtherCardCmnts'
import QuotesAdd from '../QISC/QuotesAdd'
import {
    getAllCustomGroupByEntity, findAllCustomOptionsByDropdown,
    findAllCustomFieldsByGroupAndEntity,
} from '../../../Api/Services/CustomeUIApiService';
import { setEditCall, setExPoCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { AccountsByAccountType, FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { FetchDealByAccount, FetchDealDetails, DealUpdate, createDeals } from '../../../Api/Services/DealApiService';
import { getAllUsersData, getBussinesDaysForStaffRole } from '../../../Api/Services/CommonApiService'
import { getProjectList, getProductDetails } from '../../../Api/Services/Productapiservice'
import { FetchAllServiceLines } from '../../../Api/Services/ServiceLineApiService'
import { findAllStaffRoleByReportingUser, getByAddStaffRoleId } from '../../../Api/Services/StaffRoleApiService'
import { FetchContactDetails, FetchContactByAccount } from '../../../Api/Services/ContactApiService';
// import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main, BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { convertCurrency, ExchangeCurrency, useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import Approvaldialog from '../Popup/Approvaldialog'
import Popup from '../Popup/DEMassPopup'
import CallLogPopup from '../Popup/CallLogPopup'
import NotesPopup from '../Popup/NotesPopup';
import { ShareIcon, CallLogIcon, EmailIcon, CalendarIcon, TaskIcon, NotesIcon, CloneIcon, QuotesIcon, SaveIcon, CancelIcon, DeleteIcon, ChangeOwnerIcon } from '../../../components/Icons/Icons';
import ComposeMail from '../Email/Compose';
import AllCancelPopup from '../Popup/AllCancelPopup';
import MeetingLiPopup from '../Popup/MeetingLiPopup'
import SharePopup from '../Popup/SharePopup'
import CommonFormFields from '../CustomizeUi/DynamicFieldGroup';

const { Option } = Select;

export const dealFieldConfig = {
    subtype: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.dealTypeField !== "New" && sharedProps?.dealTypeField !== "Expansion",
    }),
    parentDealId: (sharedProps) => ({
        required: sharedProps?.dealTypeField === "Expansion",
        disabled: false,
    }),
    commitStatus: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "won" || sharedProps?.pipeLineField?.toLowerCase() === "negotiation",
        disabled: sharedProps?.pipeLineField?.toLowerCase() === "prospecting" || sharedProps?.pipeLineField?.toLowerCase() === "qualification" || sharedProps?.pipeLineField?.toLowerCase() === "discovery"
    }),
    contactPerson: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: false,
    }),
    expectedDealLength: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() === "won",
        callback: sharedProps?.setChangeDealMargin,
        reset: "Yes"
    }),
    winProbability: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() === "won" || sharedProps?.pipeLineField?.toLowerCase() === "lost",
        callback: sharedProps?.setWinProbability,
        reset: "Yes"
    }),
    forecastedValue: () => ({
        required: false,
        disabled: true,
    }),
    expectedClosureDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting",
        disabled: false,
        validationType: "dateBefore",
        dependsOn: ["revenueStartDate"],
        disabledDate: (current) => {
            const start = sharedProps?.form.getFieldValue("revenueStartDate");
            const end = sharedProps?.form.getFieldValue("revenueEndDate");
            return current && (
                current.isBefore(moment(), "day") ||
                (start && current.isAfter(start, 'day')) ||
                (end && current.isAfter(end, 'day'))
            );
        }
    }),
    revenueStartDate: (sharedProps) => ({
        enableOverEdit: sharedProps?.editWon,
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment",
        disabled: sharedProps?.typeAction === "Staff Augmentation",
        validationType: "startAfterClosureAndBeforeEnd",
        dependsOn: ["expectedClosureDate", "revenueEndDate"],
        disabledDate: (current) => {
            const closure = sharedProps?.form.getFieldValue("expectedClosureDate")
            const end = sharedProps?.form.getFieldValue("revenueEndDate");
            return current && (
                current.isBefore(moment(), "day") ||
                (closure && current.isBefore(closure, 'day')) ||
                (end && current.isAfter(end, 'day'))
            );
        }
    }),
    revenueEndDate: (sharedProps) => ({
        enableOverEdit: sharedProps?.editWon,
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment",
        disabled: sharedProps?.typeAction === "Staff Augmentation",
        validationType: "dateAfter",
        dependsOn: ["revenueStartDate"],
        disabledDate: (current) => {
            const start = sharedProps?.form.getFieldValue("revenueStartDate")
            const closure = sharedProps?.form.getFieldValue("expectedClosureDate")
            return current && (
                current.isBefore(moment(), "day") ||
                (start && current.isBefore(start, 'day')) ||
                (closure && current.isBefore(closure, 'day'))
            );
        }
    }),
    grossDealValue: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment" && sharedProps?.edit,
        disabled: (sharedProps?.typeAction !== "Request for Proposal" && sharedProps?.typeAction !== "Others") || sharedProps?.dealValueEdit === "Disabled",
        callback: sharedProps?.OndealvalueChange
    }),
    discountPercentage: (sharedProps) => ({
        required: false,
        disabled: false,
        callback: sharedProps?.setDealDiscount,
        reset: "Yes"
    }),
    dealValue: () => ({
        required: false,
        disabled: true,
    }),
    dealProfit: () => ({
        required: false,
        disabled: true,
    }),
    actualCloserDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "won" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
        disabledDate: sharedProps.disabledDate,
    }),
    dealHoldDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "onhold" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
        dependsOn: ["dealRestartDate"],
        validationType: "dateBefore",
        disabledDate: sharedProps.disabledDate,
    }),
    dealRestartDate: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
        dependsOn: ["dealHoldDate"],
        validationType: "dateAfter",
        disabledDate: sharedProps.disabledDate,
    }),
    dealLostDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "lost" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "lost",
        disabledDate: sharedProps.disabledDate,
    }),
    actualDealMargin: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "won" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
    }),
    dealWonReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
    }),
    dealHoldReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
    }),
    dealLostReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "lost",
    }),
};
const LEAD_SPECIAL_FIELDS = {
    dealOwner: ({ edit, users, displayData }) => {
        return (
            edit ? <Select style={{ width: '100%' }}
                placeholder="Select Deal Owner"
                showSearch
                optionLabelProp="label"
                filterOption={(input, option) => {
                    const usernameElement = option.children.props.children[1].props.children[0];
                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                        const username = String(usernameElement.props.children);
                        return username.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                }}>
                {users}
            </Select> : <UserOwnerDetails record={{
                recordbyFName: displayData?.userFirstName,
                recordbyLName: displayData?.userLastName,
                recordby: displayData?.dealOwner,
                recordbyProfilePic: displayData?.userProfilePic
            }} />
        )
    },
    accountName: ({ edit, account, onchangeDelete, handleAccountChange, displayData }) => {
        return (
            edit ? <Select style={{ width: '100%' }}
                placeholder="Select Account Name"
                showSearch optionLabelProp="label"
                optionFilterProp="children"
                filterOption={(input, option) => {
                    const usernameElement = option.children.props.children[1].props.children[0];
                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                        const username = String(usernameElement.props.children);
                        return username.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                }
                }
                onChange={(value) => { handleAccountChange(value); onchangeDelete(value) }}
            >
                {account.filter((item) => item.accountTypeName === "Customer").map((option, i) => (
                    <Option value={option.account_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.accountName} (${option.accountNumber})`} style={{ cursor: "default" }}>
                                    {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                        < img src={option.accountProfile} alt="profile" />
                                        :
                                        <span className="image_icon AccountIcon">
                                            {option.accountName?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{option.accountName}</span>
                                </div>
                            </div>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.accountName} (${option.accountNumber})`}>
                            <div>
                                {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                    < img src={option.accountProfile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.accountName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.accountName}</p>
                                <p style={{ margin: 0 }}>{option.accountNumber}</p>
                            </div>
                        </div>
                    </Option>))
                }
            </Select> :
                <AccountDetails permission={{
                    isPresent: displayData?.accountPermission,
                    id: displayData?.account_id,
                    profile: displayData?.accountProfile,
                    name: displayData?.accountOriginalName
                }} />
        )
    },
    competition: ({ edit, accountbyType, displayData, ViewDetailPage }) => {
        return (
            edit ?
                <Select style={{ width: '100%' }}
                    placeholder="Select Competition Account"
                    showSearch mode="multiple" optionLabelProp="label"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                        const usernameElement = option.children.props.children[1].props.children[0];
                        if (usernameElement && usernameElement.props && usernameElement.props.children) {
                            const username = String(usernameElement.props.children);
                            return username.toLowerCase().includes(input.toLowerCase());
                        }
                        return false;
                    }
                    }
                >
                    {accountbyType.filter((item) => item.accountTypeName === "Competitor").map((option, i) => (
                        <Option value={option.account_id} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.accountName} (${option.accountNumber})`}>
                                {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                    < img src={option.accountProfile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                        {option.accountName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.accountName}</p>
                            </div>)}>
                            <div className='UserList-dropdown' title={`${option.accountName} (${option.accountNumber})`}>
                                <div>
                                    {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                        < img src={option.accountProfile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                        :
                                        <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.accountName?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }</div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{option.accountName}</p>
                                    <p style={{ margin: 0 }}>{option?.accountNumber}</p>
                                </div>
                            </div>
                        </Option>))
                    }
                </Select >
                : <div className='table_list_clicks' style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: "nowrap",
                    minWidth: "max-content",
                }}>
                    {displayData?.competitiondata && displayData?.competitiondata.length > 0 && (<>
                        {displayData?.competitiondata?.slice(0, 5).map((item, index) => {
                            if (!item.competitionName) {
                                return null;
                            }
                            return (
                                <TaskRelatedItem
                                    displayData={{
                                        task_type_name: "Account"
                                    }}
                                    key={index}
                                    item={{
                                        id: Number(item.competitionId),
                                        name: item?.competitionName,
                                        profilePic: item.competitionProfile
                                    }}
                                    permission={{ isPresent: item.competitionPermission }}
                                    ViewDetailPage={ViewDetailPage}
                                />
                            )
                        })}
                        {displayData?.competitiondata?.length > 5 && (
                            <Popover
                                placement="bottomLeft"
                                trigger="hover"
                                content={
                                    <div
                                        style={{
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                            padding: "4px 0",
                                        }}
                                    >
                                        {displayData?.competitiondata?.slice(5).map((item, index) => {
                                            if (!item.competitionName) {
                                                return null;
                                            }
                                            return (
                                                <TaskRelatedItem1
                                                    displayData={{
                                                        task_type_name: "Account"
                                                    }}
                                                    key={index}
                                                    item={{
                                                        id: Number(item.competitionId),
                                                        name: item?.competitionName,
                                                        profilePic: item.competitionProfile
                                                    }}
                                                    permission={{ isPresent: item.competitionPermission }}
                                                    ViewDetailPage={ViewDetailPage}
                                                />
                                            )
                                        })}
                                    </div>
                                }
                            >
                                <span
                                    style={{
                                        marginLeft: "25px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        color: "#1677ff",
                                        cursor: "pointer",
                                    }}
                                >
                                    +{displayData.competitiondata.length - 5} more
                                </span>
                            </Popover>
                        )}
                    </>)}
                </div>
        )
    },
    contactPerson: ({ contacts, edit, displayData, ViewDetailPage }) => {
        return (
            edit ?
                <Select style={{ width: '100%' }}
                    placeholder="Select Contact Person"
                    showSearch optionLabelProp="label"
                    mode="multiple"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                        const usernameElement = option.children.props.children[1].props.children[0];
                        if (usernameElement && usernameElement.props && usernameElement.props.children) {
                            const username = String(usernameElement.props.children);
                            return username.toLowerCase().includes(input.toLowerCase());
                        }
                        return false;
                    }}>
                    {contacts.map((option, i) => (
                        <Option value={option.contacts_id} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                    < img src={option.contact_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                        {option.first_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                            </div>)} >
                            <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                <div>
                                    {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                        < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                        :
                                        <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.first_name?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }</div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                    <p style={{ margin: 0 }}>{option?.email}</p>
                                </div>
                            </div>
                        </Option>))
                    }
                </Select >
                :
                <div className='table_list_clicks' style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: "nowrap",
                    minWidth: "max-content",
                }}>
                    {displayData?.contactNames && displayData?.contactNames.length > 0 && (<>
                        {displayData?.contactNames?.slice(0, 5).map((item, index) => {
                            if (!item.contactPersonName) {
                                return null;
                            }
                            return (
                                <TaskRelatedItem
                                    displayData={{
                                        task_type_name: "Contact"
                                    }}
                                    key={index}
                                    item={{
                                        id: Number(item.contactPersonId),
                                        name: item?.contactPersonName,
                                        profilePic: item.contactPersonProfileic
                                    }}
                                    permission={{ isPresent: item.contactPersonPermission }}
                                    ViewDetailPage={ViewDetailPage}
                                />
                            )
                        })}
                        {displayData?.contactNames?.length > 5 && (
                            <Popover
                                placement="bottomLeft"
                                trigger="hover"
                                content={
                                    <div
                                        style={{
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                            padding: "4px 0",
                                        }}
                                    >
                                        {displayData.contactNames.slice(5).map((item, index) => {
                                            if (!item.contactPersonName) {
                                                return null;
                                            }
                                            return (
                                                <TaskRelatedItem1
                                                    displayData={{
                                                        task_type_name: "Contact"
                                                    }}
                                                    key={index}
                                                    item={{
                                                        id: Number(item.contactPersonId),
                                                        name: item?.contactPersonName,
                                                        profilePic: item.contactPersonProfileic
                                                    }}
                                                    permission={{ isPresent: item.contactPersonPermission }}
                                                    ViewDetailPage={ViewDetailPage}
                                                />
                                            )
                                        })}
                                    </div>
                                }
                            >
                                <span
                                    style={{
                                        marginLeft: "25px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        color: "#1677ff",
                                        cursor: "pointer",
                                    }}
                                >
                                    +{displayData.contactNames.length - 5} more
                                </span>
                            </Popover>
                        )}
                    </>)}
                </div>
        )
    },
    parentDealId: ({ edit, dealTypeField, dealMapList, displayData, defaultCurrency, dealId }) => {
        return (
            edit ? <Select optionLabelProp="label"
                optionFilterProp="children" disabled={dealTypeField !== "Expansion"}
                filterOption={(input, option) => {
                    const usernameElement = option.children.props.children[1].props.children[0];
                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                        const username = String(usernameElement.props.children);
                        return username.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                }}
                style={{ width: '100%' }} placeholder="Select Parent Deal"  >
                {dealMapList.filter((item) => item.deals_id !== dealId).map((option, i) => (
                    <Option value={option.deals_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.deal_name} (${option.pipelineStage})`} style={{ cursor: "default" }}>
                                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                        < img src={option.deal_profile} alt="profile" />
                                        :
                                        <span className="image_icon DealIcon">
                                            {option.deal_name?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{option.deal_name}</span>
                                </div>
                            </div>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                            <div>
                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                    < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.deal_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                <p style={{ margin: 0 }}>{option?.pipelineStage}</p>
                            </div>
                        </div>
                    </Option>))
                }
            </Select>
                :
                <DealDetails permission={{
                    isPresent: displayData?.parentDealPermission,
                    id: displayData?.parentDealId,
                    profile: displayData?.parentDealProfile,
                    name: displayData?.parentDealName
                }}
                    currecny={defaultCurrency}
                />
        )
    }
};
const DEFAULT_DROPDOWN_FIELDS = ["dealOwner", "accountName", "competition", "contactPerson"];
const excludedFields = ["pipelineStage", "dealName", "dealOwner", "accountName", "competition", "parentDealId", "contactPerson"];
const excludedType = ["FileUpload", "MultiFileUpload"];
const DEFAULT_DROPDOWN_DISPLAY_FIELDS = {
    "dealLostReason": "dealLostReasonName",
    "dealHoldReason": "dealOnholdReasonName",
    "dealWonReason": "dealWonReasonName",
    "subtype": "subTypeName",
    "dealType": "dealTypeName",
    "priority": "priorityName",
    "commitStatus": "commitStatusName",
};

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, CallBackTrigger, ShortCut }) { // dataForDeal
    const DealprevValues = useRef({ UrlId: "", FromPage: "" });
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'deals')?.customEntityId
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const dispatch = useDispatch();
    const ProfileData = localData.profile
    const profile = ProfileData
    const defaultCurrency = localData.currency
    const permission = localData.permissions
    const Role = localData.role
    const companyProfile = localData.company
    const history = useHistory();
    const pageTypes = "Deal"
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const currentDate = new Date(currentrealTime);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const formattedTime = `${hours}:${minutes}`;
    const [form] = Form.useForm();
    const [trigger, setTrigger] = useState()
    const [users, setUsers] = useState([])
    const [tempWinProp, setTempWinProp] = useState()
    const [edit, setEdit] = useState(false)
    const [editWon, setEditWon] = useState(false)
    const [approveCondition, setApproveCondition] = useState(false)
    const [account, setAccount] = useState([])
    const [accountbyType, setAccountbyType] = useState([])
    const [optionsMap, setOptionsMap] = useState({});
    const [createPageTask, setCreatePageTask] = useState()
    const [dealMapList, setDealMapList] = useState([])
    const [pipeLineStage, setPipelineStage] = useState([])
    // const [companyId, setCompayId] = useState()
    const [editField, setEditField] = useState(false)
    const [pipelineData, setPipelineData] = useState()
    const [pipeLineField, setPipeLineField] = useState()
    const [drawerPage, setDrawerPage] = useState()
    const [dealTypeField, setDealTypeField] = useState()
    const [typeAction, setTypeAction] = useState()
    const [productdata, setProductdata] = useState([])
    const [contacts, setContacts] = useState([])
    const [dealId, setDealId] = useState()
    const [displayData, setDisplayData] = useState()
    const [dealDetailsData, setDealDetailsData] = useState()
    const [winProbability, setWinProbability] = useState()
    const [dealDiscount, setDealDiscount] = useState()
    const [serviceLineData, setServiceLineData] = useState([])
    const [action, setAction] = useState()
    const [assignOwner, setAssignOwner] = useState()
    const [notePopup, setNotePopup] = useState(false)
    const [dealIDs, setDealIDs] = useState()
    const [updatePopup, setUpdatePopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [callLogPopup, setCallLogPopup] = useState(false)
    const [NacTrigger, setNaCTrigger] = useState()
    const [approveOpen, setApproveOpen] = useState(false)
    const [dealValueEdit, setDealValueEdit] = useState()
    const [pipelineV, setPipelineV] = useState()
    const [editableType, setEditableType] = useState(false)
    const [mailOpen, setMailOpen] = useState(false)
    const [oldPipeline, setOldPipeline] = useState()
    const [OldFixed, setOldFixed] = useState()
    const [page, setPage] = useState()
    const [taskProp, setTaskProp] = useState()
    const [taskPage] = useState("AddPage")
    const [pages] = useState("Meeting")
    const [popupMessage, setPopupMessage] = useState(false)
    const [meetingOpen, setMeetingOpen] = useState(false)
    const [staffRoleData, setStaffRoleData] = useState([])
    const [contactIds, setConatctIds] = useState([])
    const [meetingAttendees, setMeetingAttendees] = useState([])
    const [emailAttendees, setEmailAttendees] = useState([])
    const [permissions] = useState(permission.entity)
    const [sharePopup, setSharePopup] = useState(false)
    const [dealValues, setDealValue] = useState(0)
    const [dataDisables, setDataDisables] = useState({ isDisable: false, allow: false, id: null, profile: null });
    const [totalDeal, setTotalDeal] = useState(0)
    const [dataPermissions, setDataPermissions] = useState()
    const [changeDealMargin, setChangeDealMargin] = useState()
    const [changeDealMargin2, setChangeDealMargin2] = useState()
    const [createPageQuote, setCratePageQuote] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [dataForQuote, setDataForQuote] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [deleteClick, setDelteClick] = useState(false)
    const [allFieldStructure, setAllFieldStructure] = useState([]);
    const [customGroups, setCustomGroups] = useState([]);
    const [customFields, setCustomFields] = useState();
    const [images, setImages] = useState({});
    const [deleteOptions, setDeleteOptions] = useState({});
    const [fileLists, setFileLists] = useState({});
    const [arrayDisplayData, setArrayDisplayData] = useState();
    const [dealInitial, setDealInitial] = useState()
    const [overAllDetails, setOverAllDetails] = useState()
    const [commitStatusId, setCommitStatusId] = useState()
    const setImage = (fieldKey, url) =>
        setImages(prev => ({ ...prev, [fieldKey]: url }));
    const setDeleteOption = (fieldKey, bool) =>
        setDeleteOptions(prev => ({ ...prev, [fieldKey]: bool }));
    const setFileList = (fieldKey, list) =>
        setFileLists(prev => ({ ...prev, [fieldKey]: list }));
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    function formatDate(value, profile) {
        if (!value) return "";
        const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
        return moment(value).format(format);
    }
    const PageCancel = () => {
        history.push('/Home/deals')
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    // Create
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        return hasRolePermission;
    };
    // Share
    // const canShare = (dataPermissions, action) => {
    //     if (!dataPermissions) return false;
    //     const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
    //     const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
    //     return hasDataPermission;
    // };
    // Update/Delete
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasRolePermission && hasDataPermission;
    };
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
                if (type === "Approve") {
                    // setTimeout(() => {
                    history.push('/Home/deals')
                    // getData(dealId); // This runs after 2 seconds
                    // }, 1000);
                }
            }
        });
    }
    const [formDatas, setFormDatas] = useState([
        {
            dealProductId: null,
            productCategory: null,
            productLicenseSellingPriceUnitMonth: null,
            numberOfUnits: null,
            licenseDuration: null,
            total: '',
        },
    ]);
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    const isFormDataValid = formDatas.every(formData => {
        return requiredFields.every(field => {
            const value = formData[field];
            return value && value !== undefined && value !== '';
        });
    });
    const [servicesData, setServiceData] = useState([
        {
            serviceName: null,
            serviceLineId: null,
            serviceLineCost: null,
        },
    ]);
    const isservicesDataValid = servicesData.every(formData => {
        return Object.values(formData).every(value => value && value !== undefined && value !== '');
    });
    const [roleData, setRoleData] = useState([
        {
            addStaffRoleId: null,
            country: null,
            rolePerDayRate: null,
            startDate: null,
            endDate: null,
            totalValue: null,
        },
    ]);
    // const isroleDataValid = roleData.every(formData => {
    //     return Object.values(formData).every(value => value && value !== undefined && value !== '');
    // });
    const onnavigate = () => {
        history.push("/Home/email-config")
    }
    const CreateQuotes = (DeId, AcId) => {
        setNaCTrigger("trigger")
        setCratePageQuote("FromDeal")
        setDataForQuote({ DealId: DeId, AccountId: AcId, dealDetails: displayData })
    }
    async function getAllAccoutbyType() {
        try {
            const data = await AccountsByAccountType()
            setAccountbyType(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const assignPipelineKeys = (pipelines) => {
        let currentKey = pipelines.find(p => p.optionType === "Default" && p.optionKey)?.optionKey || null;
        return pipelines.map((item) => {
            if (item.optionType && item.optionKey) {
                currentKey = item.optionKey;
            }
            return {
                ...item,
                optionKey: currentKey,
            };
        });
    };
    const fetchDropdownOptions = async () => {
        const allAttrs = Object.values(customFields || {}).flat();
        const dropdownIds = [...new Set(
            allAttrs
                .filter(attr => attr.dropdownId)
                .map(attr => attr.dropdownId)
        )];
        if (!dropdownIds.length) return;
        const results = await Promise.allSettled(
            dropdownIds.map(id => findAllCustomOptionsByDropdown(id))
        );
        const map = results.reduce((acc, result, index) => {
            const attr = allAttrs.find(a => a.dropdownId === dropdownIds[index]);
            if (result.status === 'fulfilled') {
                // acc[dropdownIds[index]] = result.value
                //     .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                //     .map(item => ({
                //         value: item.customDropdownOptionId,
                //         label: item.option,
                //         optionKey: item.optionKey,
                //     }));
                let options = result.value
                    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
                if (attr?.fieldKey === "pipelineStage") {
                    options = assignPipelineKeys(options);
                }
                acc[dropdownIds[index]] = options.map(item => ({
                    value: item.customDropdownOptionId,
                    label: item.option,
                    optionKey: item.optionKey,
                }));
            } else {
                acc[dropdownIds[index]] = [];
                message.error(`Failed to load "${attr?.dropdownType}" dropdown`);
            }
            return acc;
        }, {});
        setOptionsMap(map);
    };
    const fetchCustomGroupsAndFields = async () => {
        try {
            const groups = await getAllCustomGroupByEntity(ENTITY_ID);
            const sorted = [...(groups || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            const results = await Promise.all(
                sorted.map(group => findAllCustomFieldsByGroupAndEntity(ENTITY_ID, group.customFieldGroupId))
            );
            const fieldsMap = {};
            sorted.forEach((group, index) => {
                fieldsMap[group.customFieldGroupId] = [...(results[index] || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            });
            const allFields = Object.values(fieldsMap).flat();
            const structure = allFields.map((field) => ({
                entityId: field.entityId,
                fieldId: field.fieldId,
                fieldKey: field.fieldKey,
                fieldType: field.fieldType,
                fieldLabel: field.fieldLabel,
                customFieldType: field.customFieldType,
                dropdownId: field.dropdownId,
                dropdownType: field.dropdownType,
                value: field.fieldType === 'MultiFileUpload' ? [] :
                    field.fieldType === "CheckBox" ? false : null,
            }));
            batchedUpdates(() => {
                setCustomGroups(sorted);
                setCustomFields(fieldsMap);
                setAllFieldStructure(structure);
            });
        } catch {
            message.error("Failed to load custom fields");
        }
    };
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName?.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.account_id) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { accountName: displayData?.accountName, account_id: displayData?.account_id, accountTypeName: "Customer" }];
                }
            }
            if (FromPage === "ContactPage" && dataForDeal) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === dataForDeal?.contactDetails?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { accountName: dataForDeal?.contactDetails?.account_name, account_id: dataForDeal?.contactDetails?.account_id, accountTypeName: "Customer", accountNumber: dataForDeal?.contactDetails?.account_number, accountProfile: dataForDeal?.contactDetails?.account_profile }];
                }
            }
            setAccount(accountInfo)
        }
        catch (error) {
            message.error(error)
        }
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);

        return formattedDate
    }
    async function deleteMenu(id) {
        setDealIDs([id])
        setUpdatePopup(true)
        setPopupType("Delete")
    }
    async function fetchAttendeeData(id) {
        try {
            const response = await FetchContactDetails(id);
            return response.data
        } catch (error) {
            message.error(error)
        }
    }
    const handleNoteClick = (value) => {
        setNotePopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
        setPage("Entity")
    }
    const handleCallLogClick = (value) => {
        setCallLogPopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
    }
    const AssignToFucntion = () => {
        if (approveCondition) { setApproveOpen(true) }
        else {
            setDealIDs([dealId])
            setUpdatePopup(true)
            setPopupType("Change Owner")
            setAction("SingleChangeOwner")
        }
    }
    const getComitStatus = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "commitStatus")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.find(item => item.option === "Soft Commit")
            form.setFieldsValue({
                commitStatus: OriginalOrder.customDropdownOptionId
            })
            setCommitStatusId(OriginalOrder.customDropdownOptionId)
        }
        catch (error) {
            message.error(error)
        }
    };
    const handlePipeLineChange = (pipeLineStage, value, winData, type) => {
        const pipelineOgName = pipeLineStage.find(item => item.customDropdownOptionId === value)
        form.setFieldsValue({ pipelineStage: value })
        setPipelineData(value)
        setPipeLineField(pipelineOgName.optionKey)
        if (type !== "Update") {
            if (pipelineOgName.optionKey.toLowerCase() !== "prospecting" && pipelineOgName.optionKey.toLowerCase() !== "qualification" && pipelineOgName.optionKey.toLowerCase() !== "discovery") {
                getComitStatus()
            }
            else {
                form.setFieldsValue({
                    commitStatus: null
                })
            }
        }
        if (pipelineOgName.optionKey.toLowerCase() !== "won") {
            form.setFieldsValue({
                actualCloserDate: null,
                actualDealMargin: null,
                dealWonReason: null
            });
        }
        if (pipelineOgName.optionKey.toLowerCase() !== "lost") {
            form.setFieldsValue({
                dealLostDate: null,
                dealLostReason: null
            });
        }
        if (pipelineOgName.optionKey.toLowerCase() !== "onhold") {
            form.setFieldsValue({
                dealHoldDate: null,
                dealHoldReason: null,
                dealRestartDate: null
            });
        }
        if (pipelineOgName.optionKey.toLowerCase() === "onhold" || pipelineOgName.optionKey.toLowerCase() === "lost") {
            setOldPipeline(OldFixed)
        } else {
            setOldPipeline(null)
        }
        if (pipelineOgName.optionKey.toLowerCase() === "won" || pipelineOgName.optionKey.toLowerCase() === "lost") {
            form.setFieldsValue({
                winProbability: pipelineOgName.optionKey.toLowerCase() === "won" ? "100" : "0"
            })
            setWinProbability(pipelineOgName.optionKey.toLowerCase() === "won" ? "100" : "0")
        } else {
            // eslint-disable-next-line no-lonely-if
            if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                form.setFieldsValue({
                    winProbability: winData
                })
                setWinProbability(winData)
            }
        }
    }
    const handleAccountChange = async (value, rId) => {
        if (value) {
            try {
                const response = await FetchContactByAccount(value)
                const contactIds = (rId && rId !== "") ? rId?.split(',').map(id => id.trim()) : null
                const updatedContactList = response ? [...response] : [];
                if (contactIds?.length > 0) {
                    const missingIds = contactIds.filter(
                        id => !updatedContactList.some(
                            contact => String(contact.contacts_id) === String(id)
                        )
                    );
                    if (missingIds?.length > 0) {
                        try {
                            const responses = await Promise.all(
                                missingIds.map(id =>
                                    FetchContactDetails(id).catch(err => ({ error: err, id }))
                                )
                            );
                            const newContacts = responses
                                .filter(res => res && res.data && !res.error)
                                .map(res => res.data);
                            updatedContactList.push(...newContacts); // mutation is OK with const
                        } catch (err) {
                            message.error("Some contact details could not be fetched");
                        }
                    }
                }
                setContacts(updatedContactList);
            }
            catch (error) {
                message.error(error)
            }
        }
        if (value) {
            try {
                const DealList = await FetchDealByAccount(value)
                const updatedContactList = [...DealList];
                if (displayData?.parentDealId) {
                    const isAlreadyIncluded = updatedContactList.some(
                        deal => deal.deals_id === displayData.parentDealId
                    );
                    if (!isAlreadyIncluded) {
                        try {
                            const parentDealResponse = await FetchDealDetails(displayData.parentDealId);
                            if (parentDealResponse?.data) {
                                updatedContactList.push(parentDealResponse.data);
                            }
                        } catch (err) {
                            message.error(err);
                        }
                    }
                }
                setDealMapList(updatedContactList)
            }
            catch (error) {
                message.error(error)
            }
        }
    }
    const onchangeDelete = (value) => {
        if (value) {
            form.setFieldsValue({
                contactPerson: [],
                parentDealId: null
            })
        }
    }
    const handleDealTypeChange = (value, option) => {
        setDealTypeField(option?.children)
        if (option.children === "Empanelment") {
            form.setFieldsValue({
                subtype: null,
                dealValue: 0,
                grossDealValue: 0,
                dealProfit: 0,
            });
        }
        if (option.children !== "Expansion") {
            form.setFieldsValue({
                parentDealId: null
            })
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setApproveOpen(false)
        setApproveCondition(false)
        setAssignOwner()
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
        const formValues = allFieldStructure
            .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
            .reduce((acc, item) => {
                acc[item.fieldKey] =
                    item.fieldType === "Multi-Dropdown" ? [] :
                        item.fieldType === "CheckBox" ? false : null;
                return acc;
            }, {});
        form.setFieldsValue(formValues);
        setTempWinProp()
        setFileList([])
        setDealValue(0)
        setTotalDeal(0)
        setConatctIds([])
        setWinProbability()
        setDealDiscount()
        setRoleData([])
        setServiceData([])
        setFormDatas([])
        handleDealTypeChange(undefined, { children: undefined })
        setTypeAction()
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setOldPipeline()
        setOldFixed()
        setPipelineV()
        if (FromPage !== "EntityUpdate" && FromPage !== "AccountPage" && FromPage !== "ContactPage" && ShortCut !== "Shortcut") {
            GetAll();
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        if (drawerPage === "CloneDeal" || ShortCut === "Shortcut") {
            PageCancel()
        }
        setEdit(false);
        setEditWon(false);
        setEditableType(false);
        setEditField(false);
        dispatch(setEditCall(false))
        setAllFieldStructure([])
        DealprevValues.current = { UrlId: "", FromPage: "" };
        setUiReady(false);
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setDrawerPage()
        setEditWon(false);
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const mapApiResponseToFormValues = (value) => {
        return value.products.map((product) => ({
            addProductId: product.add_product_id,
            productCategory: product.product_category,
            dealProductId: product.deal_product_id,
            productLicenseSellingPriceUnitMonth: product.product_license_selling_price_unitMonth,
            numberOfUnits: product.number_of_units,
            licenseDuration: product.license_duration,
            total: product.total
        }));
    };
    const mapApiResponseToServicesValues = (value) => {
        return value.service.map((service) => ({
            serviceId: service.service_id,
            serviceName: service.service_name,
            serviceLineId: service.service_line_id,
            serviceLineCost: service.service_line_cost,
        }));
    };
    const mapApiResponseToRoleValues = (value) => {
        return value.staffRoles.map((role) => ({
            staffRoleId: role.staff_role_id,
            addStaffRoleId: role.add_staff_role_id,
            roleName: role.roleName,
            country: role.country,
            rolePerDayRate: role.role_per_day_rate,
            startDate: role.start_date,
            endDate: role.end_date,
            totalValue: role.total_value,
        }));
    };
    function totalCalculation() {
        let sum = 0;
        let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        let ChcekdealValueEdit;
        if (typeAction === "Product and Services" || typeAction === "Request for Proposal" || typeAction === "Others") {
            if (isFormDataValid || isservicesDataValid) {
                if (formDatas.length === 0 && servicesData.length === 0) {
                    sum = Number(dealValues) || 0;
                    setDealValueEdit()
                    ChcekdealValueEdit = undefined
                }
                else {
                    if (formDatas.length > 0) {
                        for (let i = 0; i < formDatas.length; i += 1) {
                            if (formDatas[i].total !== undefined)
                                sum += 1 * formDatas[i].total;
                        }
                    }
                    else if (!isservicesDataValid) {
                        sum = Number(dealValues) || 0;
                    }
                    if (servicesData.length > 0) {
                        for (let i = 0; i < servicesData.length; i += 1) {
                            if (servicesData[i].serviceLineCost !== undefined)
                                sum += 1 * servicesData[i].serviceLineCost;
                        }
                    }
                    else if (!isFormDataValid) {
                        sum = Number(dealValues) || 0;
                    }
                    if ((formDatas.length > 0 && isFormDataValid) || (servicesData.length > 0 && isservicesDataValid)) {
                        setDealValueEdit("Disabled")
                        ChcekdealValueEdit = "Disabled"
                    }
                    else {
                        setDealValueEdit()
                        ChcekdealValueEdit = undefined
                    }
                }
            }
            else if (typeAction === "Request for Proposal" || typeAction === "Others") {
                sum = Number(dealValues) || 0;
            }
        }
        if (typeAction === "Staff Augmentation") {
            // if (isroleDataValid) {
            for (let i = 0; i < roleData.length; i += 1) {
                if (roleData[i].totalValue !== undefined)
                    sum += 1 * roleData[i].totalValue;
            }
            // } else {
            //     sum = 0
            // }
        }
        if (!Number.isNaN(Number(dealDiscount)) && dealDiscount !== "" && dealDiscount !== 0) {
            totalsum = sum * (1 - Number(dealDiscount) / 100);
        } else {
            totalsum = sum;
        }
        if (!Number.isNaN(Number(winProbability)) && winProbability !== "" && totalDeal) {
            const dValue = 1 * totalDeal;
            Fvalue = dValue * (Number(winProbability) / 100);
        }
        if (pipeLineField?.toLowerCase() !== "won") {
            if (!Number.isNaN(Number(changeDealMargin)) && changeDealMargin !== "" && totalDeal) {
                const dValue = 1 * totalDeal;
                profit = dValue * (Number(changeDealMargin) / 100);
            }
        } else if (pipeLineField?.toLowerCase() === "won") {
            if (!Number.isNaN(Number(changeDealMargin2)) && changeDealMargin2 !== "" && totalDeal) {
                const dValue = 1 * totalDeal;
                profit = dValue * (Number(changeDealMargin2) / 100);
            }
        }
        form.setFieldsValue({
            dealValue: totalsum?.toFixed(CurencyDecimalPlace),
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace),
            dealProfit: profit?.toFixed(CurencyDecimalPlace)
        })
        if (((typeAction !== "Request for Proposal" && typeAction !== "Others") || ChcekdealValueEdit === "Disabled")) {
            form.setFieldsValue({
                grossDealValue: sum?.toFixed(CurencyDecimalPlace),
            })
        }
        setTotalDeal(totalsum);
    }
    async function preprocessFormValues(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Multi-Dropdown":
                        newValue = cf.value ? cf.value.split(",").map(id => Number(id)) : [];
                        break;
                    case "Dropdown":
                        newValue = cf.value !== undefined && cf.value !== null ? Number(cf.value) : null;
                        break;
                    case "Number":
                    case "Percentage":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Currency": {
                        const convertedCost = cf.value ? await ExchangeCurrency(Number(cf.value), ConvertRate) : null;
                        newValue = convertedCost ? Number(convertedCost?.toFixed(CurencyDecimalPlace)) : null;
                        break;
                    }
                    case "Date":
                        newValue = cf.value ? moment(cf.value) : null;
                        break;
                    case "CheckBox":
                        newValue = cf.value === "1" || cf.value === 1 || cf.value === true || cf.value === "true";
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        case "Multi-Dropdown":
                            val = val ? val.split(",").map(id => Number(id)) : [];
                            break;
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_FIELDS.includes(item.fieldKey)) {
                                val = normalizeValue(val)
                            } else {
                                val = val !== undefined && val !== null ? Number(val) : null;
                            }
                            break;
                        }
                        case "Number":
                        case "Percentage":
                            val = val !== undefined && val !== null ? Number(val) : null;
                            break;
                        case "Currency": {
                            const convertedCost = val ? await ExchangeCurrency(Number(val), ConvertRate) : null;
                            val = convertedCost ? Number(convertedCost?.toFixed(CurencyDecimalPlace)) : null;
                            break;
                        }
                        case "Date":
                            val = val ? moment(val) : null;
                            break;
                        case "CheckBox":
                            val = val === "1" || val === 1 || val === true || val === "true";
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    async function preprocessFormDisplay(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Multi-Dropdown":
                        newValue = cf.option;
                        break;
                    case "Dropdown":
                        newValue = cf.option;
                        break;
                    case "Number":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Percentage":
                        newValue = cf.value ? `% ${Number(cf.value)}` : null;
                        break;
                    case "Currency": {
                        const convertedCost = cf.value ? await ExchangeCurrency(Number(cf.value), ConvertRate) : null;
                        newValue = convertedCost ? `${defaultCurrency?.symbol} ${Number(convertedCost?.toFixed(CurencyDecimalPlace))?.toLocaleString()}` : null;
                        break;
                    }
                    case "Date":
                        newValue = cf.value ? formatDate(cf.value, profile) : null;
                        break;
                    case "CheckBox":
                        newValue = (cf.value === "1" || cf.value === 1 || cf.value === true || cf.value === "true") ? "Yes" : "No";
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        // case "Multi-Dropdown":
                        //     val = val ? val.split(",").map(id => Number(id)) : [];
                        //     break;
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_DISPLAY_FIELDS[item.fieldKey]) {
                                const displayKey = DEFAULT_DROPDOWN_DISPLAY_FIELDS[item.fieldKey];
                                val = displayKey
                                    ? normalizeValue(formattedValue[displayKey])
                                    : normalizeValue(val);
                            } else {
                                val = val !== undefined && val !== null ? normalizeValue(val) : null;
                            }
                            break;
                        }
                        case "Number":
                            val = val !== undefined && val !== null ? Number(val) : null;
                            break;
                        case "Percentage":
                            val = val !== undefined && val !== null ? `% ${Number(val)}` : null;
                            break;
                        case "Currency": {
                            const convertedCost = val ? await ExchangeCurrency(Number(val), ConvertRate) : null;
                            val = convertedCost ? `${defaultCurrency?.symbol} ${Number(convertedCost?.toFixed(CurencyDecimalPlace))?.toLocaleString()}` : null;
                            break;
                        }
                        case "Date":
                            val = val ? formatDate(val, profile) : null;
                            break;
                        case "CheckBox":
                            val = (val === "1" || val === 1 || val === true || val === "true") ? "Yes" : "No";
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    async function preprocessFormValues1(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Dropdown":
                    case "Number":
                    case "Percentage":
                    case "Currency":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Multi-Dropdown":
                    case "Date":
                        newValue = cf.value ? String(cf.value) : null;
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_FIELDS.includes(item.fieldKey)) {
                                val = normalizeValue(val)
                            } else {
                                val = val !== undefined && val !== null ? Number(val) : null;
                            }
                            break;
                        }
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Number":
                        case "Percentage":
                        case "Currency":
                            val = val ? Number(val) : null;
                            break;
                        case "Multi-Dropdown":
                        case "Date":
                            val = val ? String(val) : null;
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    const setData = async (value) => {
        if (value !== undefined) {
            const formattedValue = await preprocessFormValues(value, allFieldStructure);
            const formattedValue1 = await preprocessFormValues1(value, allFieldStructure);
            const formatteddisplayValue = await preprocessFormDisplay(value, allFieldStructure);
            const formValuess = allFieldStructure.reduce((acc, item) => {
                const fieldKeys = item.fieldKey;
                let fieldValue;
                if (item.customFieldType === "Custom") {
                    const cf = formattedValue?.customFieldValues?.find(cf => cf.fieldId === item.fieldId);
                    fieldValue = cf ? cf.value ?? null : null;
                } else {
                    fieldValue = formattedValue[fieldKeys];
                }
                acc[fieldKeys] =
                    item.fieldType === "Multi-Dropdown"
                        ? fieldValue || []
                        : normalizeValue(fieldValue) ?? null;

                return acc;
            }, {});
            const updatedFieldStructure = allFieldStructure.map(item => {
                const fieldKeys = item.fieldKey;
                let fieldValue;
                if (item.customFieldType === "Custom") {
                    const cf = formattedValue1?.customFieldValues?.find(cf => cf.fieldId === item.fieldId);
                    fieldValue = cf ? cf.value ?? null : null;
                } else {
                    fieldValue = formattedValue1[fieldKeys];
                }
                // if (item.fieldType === "Date" && fieldValue) {
                //     fieldValue = moment(fieldValue).format("YYYY-MM-DD");
                // }
                return {
                    ...item,
                    value: fieldValue
                    // type === "Edit"
                    //     ? (item.fieldType === "Multi-Dropdown"
                    //         ? fieldValue ? fieldValue.join(",") : []
                    //         : normalizeValue(fieldValue) ?? null)
                    //     : (item.fieldType === "Multi-Dropdown"
                    //         ? []
                    //         : null)
                };
            });
            const formValues = mapApiResponseToFormValues(value);
            const servicesValues = mapApiResponseToServicesValues(value);
            const roleValues = mapApiResponseToRoleValues(value)
            const convertedServicesData = await Promise.all(
                servicesValues.map(async (service) => {
                    const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                        ExchangeCurrency(Number(service.serviceLineCost), ConvertRate)
                        : service.serviceLineCost
                    );
                    return {
                        ...service,
                        serviceLineCost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedServices = await Promise.all(
                value.service.map(async (service) => {
                    const convertedCost = await (service.service_line_cost !== undefined && service.service_line_cost !== null && service.service_line_cost !== "" ?
                        ExchangeCurrency(Number(service.service_line_cost), ConvertRate)
                        : service.service_line_cost
                    );
                    return {
                        ...service,
                        service_line_cost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedRoleData = await Promise.all(
                roleValues.map(async (role) => {
                    const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                        ? ExchangeCurrency(Number(role.rolePerDayRate), ConvertRate)
                        : role.rolePerDayRate);
                    const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== ""
                        ? ExchangeCurrency(Number(role.totalValue), ConvertRate)
                        : role.totalValue);
                    return {
                        ...role,
                        rolePerDayRate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        totalValue: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedRole = await Promise.all(
                value.staffRoles.map(async (role) => {
                    const convertedRate = await (role.role_per_day_rate !== undefined && role.role_per_day_rate !== null && role.role_per_day_rate !== ""
                        ? ExchangeCurrency(Number(role.role_per_day_rate), ConvertRate) : role.role_per_day_rate);
                    const convertedTotalValue = await (role.total_value !== undefined && role.total_value !== null && role.total_value !== ""
                        ? ExchangeCurrency(Number(role.total_value), ConvertRate) : role.total_value);
                    return {
                        ...role,
                        role_per_day_rate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        total_value: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedFormDatas = await Promise.all(
                formValues.map(async (product) => {
                    const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                        ? ExchangeCurrency(Number(product.productLicenseSellingPriceUnitMonth), ConvertRate)
                        : product.productLicenseSellingPriceUnitMonth);
                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                        ? ExchangeCurrency(Number(product.total), ConvertRate)
                        : product.total);
                    return {
                        ...product,
                        productLicenseSellingPriceUnitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                        // subtotal: Number(convertedSubtotal?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                        // adjustments: product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null && product.adjustmentType !== "%" ? Number(convertedAdjustments?.toFixed(CurencyDecimalPlace)) : convertedAdjustments,
                    };
                })
            );
            const convertedForm = await Promise.all(
                value.products.map(async (product) => {
                    const convertedPrice = await (product.product_license_selling_price_unitMonth !== undefined && product.product_license_selling_price_unitMonth !== '' && product.product_license_selling_price_unitMonth !== null
                        ? ExchangeCurrency(Number(product.product_license_selling_price_unitMonth), ConvertRate) : product.product_license_selling_price_unitMonth);
                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                        ? ExchangeCurrency(Number(product.total), ConvertRate) : product.total);
                    return {
                        ...product,
                        product_license_selling_price_unitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            if (drawerPage !== "CloneLead") {
                if (value.approved_for !== "None") {
                    setApproveOpen(true)
                    setApproveCondition(true)
                }
                else {
                    setApproveOpen(false)
                    setApproveCondition(false)
                }
                setDealInitial({
                    oldPipelineStage: normalizeValue(value.old_pipeline_stage),
                    staffRole: roleValues,
                    products: formValues,
                    services: servicesValues,
                })
            } else {
                setDealInitial({
                    oldPipelineStage: null,
                    staffRole: [],
                    products: [],
                    services: [],
                })
            }
            setAssignOwner(value.dealOwner)
            const DealValue = value.dealValue ? await ExchangeCurrency(Number(value.dealValue), ConvertRate) : value.dealValue;
            const GrossDealValue = value.grossDealValue ? await ExchangeCurrency(Number(value.grossDealValue), ConvertRate) : value.grossDealValue;
            setAllFieldStructure(updatedFieldStructure)
            form.setFieldsValue(formValuess);
            setOverAllDetails(formValuess)
            setImage('dealProfile', formattedValue.dealProfile ?? null);
            setDeleteOption('dealProfile', !!(formattedValue.dealProfile && formattedValue.dealProfile !== ''));
            setFileList('dealFiles', formattedValue.dealFiles || []);
            setChangeDealMargin(value.expectedDealLength)
            setChangeDealMargin2(value.actualDealMargin !== undefined && value.actualDealMargin !== null && value.actualDealMargin !== "" ? value.actualDealMargin : value.actualDealMargin)
            setTempWinProp(value.winProbability)
            setDealValue(Number(GrossDealValue?.toFixed(CurencyDecimalPlace)))
            setTotalDeal(Number(DealValue?.toFixed(CurencyDecimalPlace)))
            setConatctIds(value.contactPerson ? value.contactPerson.split(",").map(user => user * 1) : [])
            setWinProbability(value.winProbability)
            setDealDiscount(value.discountPercentage)
            setRoleData(convertedRoleData)
            setServiceData(convertedServicesData)
            setFormDatas(convertedFormDatas)
            setDealId(value.deals_id)
            handleDealTypeChange(value.dealType, { children: value.dealTypeName })
            setTypeAction(value.subTypeName)
            setStates({
                ...states,
                selectedRowKeys: [value.deals_id]
            });
            if ((drawerPage === "CloneDeal" && (value.pipelineStageName === "Won" || value.pipelineStageName === "Lost"))) {
                handlePipeLineChange(pipeLineStage, pipeLineStage[0].customDropdownOptionId, value.winProbability, "Update")
                setPipelineV()
                setOldPipeline(null)
                setOldFixed()
                setEditableType(true)
            } else {
                handlePipeLineChange(pipeLineStage, value.pipelineStage, value.winProbability, "Update")
                if (Role !== "Administrator") {
                    if (value.pipelineStageName === "Won" || value.pipelineStageName === "Lost") {
                        setEditWon(true)
                        setEditableType(false)
                    } else {
                        setEditableType(true)
                    }
                }
                else {
                    setEditableType(true)
                }
                setPipelineV(value.pipelineStageName)
                if ((value.pipelineStageName !== "on-Hold" && value.pipelineStageName !== "On-Hold") && value.pipelineStageName !== "Lost") {
                    setOldPipeline(value.pipelineStage)
                    setOldFixed(value.pipelineStage)
                }
                else {
                    setOldPipeline(value.old_pipeline_stage)
                    setOldFixed(value.old_pipeline_stage)
                }
            }
            const updatedPerson = {
                ...value,
                products: convertedForm,
                service: convertedServices,
                staffRoles: convertedRole,
                created_at: value.created_at ? convertAndFormatDateTime(value.created_time ? `${value.created_at} ${value.created_time}` : value.created_at, companyProfile, profile) : "",
                modified_at: value.modified_at ? convertAndFormatDateTime(value.modified_time ? `${value.modified_at} ${value.modified_time}` : value.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(updatedPerson)
            const transformedItem = {
                ...value,
                created_at: value.created_at ? convertAndFormatDateTime(value.created_time ? `${value.created_at} ${value.created_time}` : value.created_at, companyProfile, profile) : "",
                modified_at: value.modified_at ? convertAndFormatDateTime(value.modified_time ? `${value.modified_at} ${value.modified_time}` : value.modified_at, companyProfile, profile) : "",
            };
            setDealDetailsData(transformedItem)
            const groupedData = customGroups
                .map(group => {
                    const groupId = group.customFieldGroupId;
                    const fields = (customFields?.[groupId] || [])
                        .filter(field =>
                            !excludedFields.includes(field.fieldKey) &&
                            !excludedType.includes(field.fieldType) &&
                            field.fieldVisible === 'Yes'
                        )
                        .map(field => {
                            let value;
                            if (field.customFieldType === "Custom") {
                                const cf = formatteddisplayValue?.customFieldValues?.find(
                                    c => c.fieldId === field.fieldId
                                );
                                value = cf?.value ?? null;
                            } else {
                                value = formatteddisplayValue[field.fieldKey];
                            }
                            return {
                                ...field,
                                value:
                                    field.fieldType === "Multi-Dropdown"
                                        ? value || []
                                        : normalizeValue(value) ?? null
                            };
                        });
                    return {
                        ...group,
                        fields
                    };
                });
            setArrayDisplayData(groupedData);
            if (convertedFormDatas.length === 0 && convertedServicesData.length === 0 && (value.subTypeName === "Request for Proposal" || value.subTypeName === "Others")) {
                form.setFieldsValue({
                    grossDealValue: GrossDealValue?.toFixed(CurencyDecimalPlace),
                })
            }
        }
    }
    async function getSharingPermissions(id) {
        if (id) {
            setDataPermissions(id)
        }
        else {
            setDataPermissions("Read,Update,Delete,Sharing")
        }
    }
    async function getData(id) {
        try {
            if (drawerPage === "CloneDeal") {
                const responseData = await FetchDealDetails(id);
                const response = responseData.data;
                getSharingPermissions(undefined);
                setData(response);
            } else {
                const responseData = await FetchDealDetails(id);
                if (!responseData.allow) throw new Error();
                const response = responseData.data;
                getSharingPermissions(response?.sharingPermission?.sharePermission);
                setData(response);
            }
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function getData1(id, hideMessagefn, AutomationMessages, ApprovalMessages, responseData, pipelineID) {
        try {
            const response = await FetchDealDetails(id);
            hideMessagefn();
            if (responseData.data[0].message === AutomationMessages) {
                if (pipelineID?.toLowerCase() === "won") {
                    dispatch(setExPoCall(true));
                    successMessage("Automation rule triggered", responseData.data[0].message)
                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                } else {
                    successMessage("Automation rule triggered", responseData.data[0].message)
                }
            }
            else if (responseData.data[0].message !== ApprovalMessages && responseData.data[0].message !== AutomationMessages) {
                if (pipelineID?.toLowerCase() === "won") {
                    dispatch(setExPoCall(true));
                    successMessage("Deal Won",
                        <>
                            <img
                                src={require('../../../static/img/defaultImages/Won.gif')}
                                alt="celebration"
                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                            />
                            <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                        </>)
                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                } else {
                    message.success(
                        <span>
                            Deal <strong>{responseData?.data?.[0]?.entityName}</strong> has been updated successful
                        </span>
                    );
                }
            }
            else {
                message.success(
                    <span>
                        Deal <strong>{responseData?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            if (!response.allow) throw new Error();
            getSharingPermissions(response?.data.sharingPermission?.sharePermission)
            setData(response.data);
            setTrigger("activity")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessagefn();
            loadingRef.current = false;
            setDoubleClick(false)
            if (responseData.data[0].message === AutomationMessages) {
                if (pipelineID?.toLowerCase() === "won") {
                    dispatch(setExPoCall(true));
                    successMessage("Automation rule triggered", responseData.data[0].message)
                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                } else {
                    successMessage("Automation rule triggered", responseData.data[0].message)
                }
            }
            else if (responseData.data[0].message !== ApprovalMessages && responseData.data[0].message !== AutomationMessages) {
                if (pipelineID?.toLowerCase() === "won") {
                    dispatch(setExPoCall(true));
                    successMessage("Deal Won",
                        <>
                            <img
                                src={require('../../../static/img/defaultImages/Won.gif')}
                                alt="celebration"
                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                            />
                            <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                        </>)
                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                } else {
                    message.success(
                        <span>
                            Deal <strong>{responseData?.data?.[0]?.entityName}</strong> has been updated successfully
                        </span>
                    );
                }
            }
            else {
                message.success(
                    <span>
                        Deal <strong>{responseData?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted();
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setDealId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }

        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function ProductApi() {
        try {
            const data = await getProjectList()
            const options = data.filter((item) => item.productActive === "Yes").map((option, i) => (
                <Option value={option.dealProductId} key={i} label={option.productName
                    // (<div style={{ display: 'flex', alignItems: 'center' }} title={`${option.productName} (${option.prodcutCategory})`}>
                    //     <div className='Div_flex2'>
                    //         <div className='share_image' title={`${option.productName} (${option.prodcutCategory})`} style={{ cursor: "default" }}>
                    //             {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                    //                 < img src={option.productImg} alt="profile" />
                    //                 :
                    //                 <span className="image_icon">
                    //                     {option.productName?.slice(0, 1).toUpperCase()}
                    //                 </span>
                    //             }
                    //             <span className='div-ellipsis'>{option.productName}</span>
                    //         </div>
                    //     </div>
                    // </div>)
                }>
                    <div className='UserList-dropdown' title={`${option.productName} (${option.prodcutCategory})`}>
                        <div>
                            {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                                < img src={option.productImg} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.productName?.slice(0, 1).toUpperCase()}
                                </span>
                            }
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.productName}</p>
                            <p style={{ margin: 0 }}>({option.prodcutCategory})</p>
                        </div>
                    </div>
                </Option>));
            setProductdata(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function ServiceLineApi() {
        try {
            const data = await FetchAllServiceLines()
            const options = data.map((option, i) => (
                <Option value={option.service_line_id} key={i} label={option.service_line_name
                    // (<div style={{ display: 'flex', alignItems: 'center' }} >
                    //     <div className='Div_flex2'>
                    //         <div className='share_image' title={option.service_line_name} style={{ cursor: "default" }}>
                    //             <span className="image_icon">
                    //                 {option.service_line_name?.slice(0, 1).toUpperCase()}
                    //             </span>
                    //             <span className='div-ellipsis'>{option.service_line_name}</span>
                    //         </div>
                    //     </div>
                    // </div>)
                }>
                    <div className='UserList-dropdown' title={option.service_line_name}>
                        <div>
                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                {option.service_line_name?.slice(0, 1).toUpperCase()}
                            </span>
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.service_line_name}</p>
                        </div>
                    </div>
                </Option>));
            setServiceLineData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function StaffRoleApi() {
        try {
            const data = await findAllStaffRoleByReportingUser()
            setStaffRoleData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getPipelineStage = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "pipelineStage")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            const newPipiline = assignPipelineKeys(OriginalOrder)
            setPipelineStage(newPipiline)
            if (FromPage === "AccountPage" || FromPage === "ContactPage" || FromPage === "ListingDealCreate" || drawerPage === "CloneDeal") {
                handlePipeLineChange(newPipiline, newPipiline[0].customDropdownOptionId)
                form.setFieldsValue({
                    pipelineStage: newPipiline[0].customDropdownOptionId
                })
            }
        }
        catch (error) {
            setPipelineStage([])
            message.error(error)
        }
    };
    const getPriority = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "priority")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            form.setFieldsValue({
                priority: OriginalOrder[0].customDropdownOptionId
            })
        }
        catch (error) {
            message.error(error)
        }
    };
    async function getSelleingPrice(id) {
        try {
            const response = await getProductDetails(id)
            const price = response.sellingPricePerUnitPerMonth;
            const category = response.prodcutCategory;
            return { success: true, price, category };
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    async function getStaffRolePrice(id) {
        try {
            const datas = await getByAddStaffRoleId(id);
            const price = datas.rolePerDayRate;
            return { success: true, price };
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    const getWorkingDays = async (id, startDate, endDate) => {
        try {
            const response = await getBussinesDaysForStaffRole(id, startDate, endDate)
            return { success: true, data: response }
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    // add Product
    const handleFieldChange = async (index, fieldName, value) => {
        const updatedFormData = [...formDatas];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };

        const productId = updatedFormData[index].dealProductId;
        if (productId) {
            const response = await getSelleingPrice(productId)
            if (!response.success) {
                message.error(response.message);
                updatedFormData[index].productLicenseSellingPriceUnitMonth = 0;
                updatedFormData[index].productCategory = null;
                updatedFormData[index].licenseDuration = 1;
            }
            else {
                const Value = response.price
                    ? await ExchangeCurrency(Number(response.price), ConvertRate)
                    : response.price;
                updatedFormData[index].productLicenseSellingPriceUnitMonth = Number(Value?.toFixed(CurencyDecimalPlace));
                updatedFormData[index].productCategory = response.category;
                if (response.category !== "Software") {
                    updatedFormData[index].licenseDuration = 1;
                } else {
                    updatedFormData[index].licenseDuration = updatedFormData[index].licenseDuration && updatedFormData[index].licenseDuration !== "" ?
                        updatedFormData[index].licenseDuration : 1
                }
            }
        }
        const productLicenseSellingPriceUnitMonth = parseFloat(updatedFormData[index].productLicenseSellingPriceUnitMonth || 0);
        const numberOfUnits = parseFloat(updatedFormData[index].numberOfUnits || 0);
        const licenseDuration = parseFloat(updatedFormData[index].licenseDuration || 0);
        if (productLicenseSellingPriceUnitMonth > 0 && numberOfUnits > 0 && licenseDuration > 0) {
            updatedFormData[index].total = (productLicenseSellingPriceUnitMonth * numberOfUnits * licenseDuration)?.toFixed(CurencyDecimalPlace);
        } else {
            updatedFormData[index].total = "";

        }
        setFormDatas(updatedFormData)
    };
    const addNewRow = () => {
        setFormDatas([...formDatas,
        {
            dealProductId: null,
            productCategory: null,
            productLicenseSellingPriceUnitMonth: null,
            numberOfUnits: null,
            licenseDuration: null,
            total: null,
        }]);
    };
    const removeRow = async (index) => {
        const updatedFormData = [...formDatas];
        updatedFormData.splice(index, 1);
        setFormDatas(updatedFormData);
    }
    // add services
    const addNewSerivce = () => {
        setServiceData([...servicesData,
        {
            serviceName: null,
            serviceLineId: null,
            serviceLineCost: null,
        },
        ]);
    };
    const removeservice = async (index) => {
        const updatedFormData = [...servicesData];
        updatedFormData.splice(index, 1);
        setServiceData(updatedFormData);
    };
    const handleServicesChange = async (index, fieldName, value) => {
        const updatedFormData = [...servicesData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };
        setServiceData(updatedFormData);
    };
    // add roles
    const addNewRoles = () => {
        setRoleData([...roleData, {
            addStaffRoleId: null,
            country: null,
            rolePerDayRate: null,
            startDate: null,
            endDate: null,
            totalValue: null,
        }]);
    };
    const removeRoles = async (index) => {
        const updatedFormData = [...roleData];
        updatedFormData.splice(index, 1);
        setRoleData(updatedFormData);
    };
    const handleRolesChange = async (index, fieldName, value, countrys) => {
        const updatedFormData = [...roleData];
        if ((fieldName === "startDate" || fieldName === "endDate") && value) {
            const date = RequiredDateFormating(value)
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: date,
                country: countrys,
            };
        }
        else {
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                country: countrys,
            };
        }
        const staffRoleId = updatedFormData[index].addStaffRoleId;
        if (staffRoleId) {
            const response = await getStaffRolePrice(staffRoleId)
            if (!response.success) {
                message.error(response.message);
                updatedFormData[index].rolePerDayRate = 0;
            }
            else {
                const Value = response.price ?
                    await ExchangeCurrency(Number(response.price), ConvertRate)
                    : response.price;
                updatedFormData[index].rolePerDayRate = Number(Value?.toFixed(CurencyDecimalPlace));
            }
        }
        const rolePerDayRate = parseFloat(updatedFormData[index].rolePerDayRate || 0);
        let totalBusinessDays = 0;

        if (staffRoleId && updatedFormData[index].startDate && updatedFormData[index].endDate) {
            const responseData = await getWorkingDays(staffRoleId, updatedFormData[index].startDate, updatedFormData[index].endDate);
            if (!responseData.success) {
                message.error(responseData.message);
                totalBusinessDays = 0;
            }
            else {
                totalBusinessDays = responseData.data
            }
        } if (rolePerDayRate > 0 && totalBusinessDays > 0) {
            const total = rolePerDayRate * totalBusinessDays
            updatedFormData[index].totalValue = total?.toFixed(CurencyDecimalPlace)
        }
        else {
            updatedFormData[index].totalValue = ""
        }
        setRoleData(updatedFormData);
    };
    const handleTypeAction = (value, option) => {
        setTypeAction(option.children)
        if (option.children === "Staff Augmentation" && roleData.length === 0) {
            addNewRoles()
            form.setFieldsValue({
                revenueStartDate: null,
                revenueEndDate: null,
            })
        }
        if (option.children === "Request for Proposal" || option.children === "Product and Services") {
            if (formDatas.length === 0) {
                addNewRow()
            }
            if (servicesData.length === 0) {
                addNewSerivce()
            }
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const HandleShareClick = () => {
        setSharePopup(true)
    }
    const ProductColumns = [
        {
            title: 'Product Name',
            dataIndex: 'PrdutName',
            key: 'PrdutName',
            width: '18%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Select style={{ width: "100%" }}
                        showSearch
                        optionLabelProp="label"
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                            const usernameElement = option.children.props.children[1].props.children[0];
                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                const username = String(usernameElement.props.children);
                                return username.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }
                        }
                        placeholder="Select Product"
                        name="dealProductId"
                        value={record.dealProductId}
                        onChange={(value) =>
                            handleFieldChange(index, 'dealProductId', value)
                        }
                    >
                        {productdata}
                    </Select>
                        : <span >
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.product_name : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: `Unit Price (${defaultCurrency?.currency})`,
            dataIndex: 'PriceperU/M$',
            key: 'PriceperU/M$',
            width: '13%',
            render: (text, record, index) => (
                <Form.Item>
                    {edit ? <Input pattern="^\d+(\.\d+)?$" disabled prefix={defaultCurrency?.symbol}
                        name="productLicenseSellingPriceUnitMonth"
                        value={record.productLicenseSellingPriceUnitMonth}
                        onChange={(e) =>
                            handleFieldChange(index, 'productLicenseSellingPriceUnitMonth', e.target.value)
                        }
                        placeholder="Unit Price" />
                        :
                        <>{defaultCurrency?.symbol} <span>
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.product_license_selling_price_unitMonth?.toLocaleString() : ""}
                        </span>
                        </>
                    }
                </Form.Item>
            ),
        },
        {
            title: 'No. of Units',
            dataIndex: 'Numofunits',
            key: 'Numofunits',
            width: '5%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input min={0}
                        name="numberOfUnits"
                        value={record.numberOfUnits}
                        onChange={(e) => {
                            const { value } = e.target;
                            const isValid = /^\d+(\.\d+)?$/.test(value);
                            if (value === "" || isValid) {
                                handleFieldChange(index, "numberOfUnits", value);
                            }
                        }}
                        placeholder="Number of Units" />
                        : <span >
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.number_of_units : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: (
                <div>
                    Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="License Duration in months" />
                </div>
            ),
            dataIndex: 'LicenseDutn',
            key: 'LicenseDutn',
            width: '5%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input min={0}
                        disabled={record.productCategory !== "Software"}
                        name="licenseDuration"
                        value={record.productCategory && record.productCategory !== "Software" ? "One off" : record.licenseDuration}
                        onChange={(e) => {
                            const { value } = e.target;
                            const isValid = /^\d+(\.\d+)?$/.test(value);
                            if (value === "" || isValid) {
                                handleFieldChange(index, "licenseDuration", value);
                            }
                        }}
                        placeholder="License Duration" />
                        : <span >
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.license_duration : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: `Total (${defaultCurrency?.currency})`,
            dataIndex: 'Total',
            key: 'Total',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item>
                    {edit ? <Input type="text" disabled prefix={defaultCurrency?.symbol}
                        name="total"
                        value={record.total}
                        onChange={(e) =>
                            handleFieldChange(index, 'total', e.target.value)
                        }
                        placeholder="Total" />
                        : <>{defaultCurrency?.symbol} <span >
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.total?.toLocaleString() : ""}
                        </span></>}
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '2%',
            render: (text, record, index) => {
                if (edit && formDatas.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            onClick={() => removeRow(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            width: '2%',
            render: (text, record, index) => {
                if (edit && index === formDatas.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Product"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewRow}
                        />
                    );
                }
            },
        }
    ];
    const ServicesColumns = [
        {
            title: 'Service Name',
            dataIndex: 'ServiceName',
            key: 'ServiceName',
            width: '30%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input placeholder='Enter Service Name'
                        name="serviceName"
                        value={record.serviceName}
                        onChange={(e) =>
                            handleServicesChange(index, 'serviceName', e.target.value)
                        } />
                        : <span >
                            {displayData?.service?.length > 0 ? displayData?.service[index]?.service_name : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: 'Service Line Name',
            dataIndex: 'ServiceLineName',
            key: 'ServiceLineName',
            width: '35%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ?
                        <Select style={{ width: "100%" }}
                            showSearch
                            optionLabelProp="label"
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                                const usernameElement = option.children.props.children[1].props.children[0];
                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                    const username = String(usernameElement.props.children);
                                    return username.toLowerCase().includes(input.toLowerCase());
                                }
                                return false;
                            }
                            }
                            placeholder="Enter Service Line Name"
                            name="serviceLineId"
                            value={record.serviceLineId}
                            onChange={(value) =>
                                handleServicesChange(index, 'serviceLineId', value)
                            }
                        >
                            {serviceLineData}
                        </Select>
                        : <span>
                            {displayData?.service?.length > 0 ? displayData?.service[index]?.service_line_name : ""}
                        </span>
                    }
                </Form.Item>
            ),
        },
        {
            title: `Service Line Cost (${defaultCurrency?.currency})`,
            dataIndex: 'ServiceLineCost',
            key: 'ServiceLineCost',
            width: '31%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input placeholder='Enter Service Line Cost' min={0} prefix={defaultCurrency?.symbol}
                        name="serviceLineCost"
                        value={record.serviceLineCost}
                        onChange={(e) => {
                            const { value } = e.target;
                            if (value === "") {
                                handleServicesChange(index, "serviceLineCost", value);
                                return;
                            }
                            const basicNumberCheck = /^\d+(\.\d*)?$/;
                            if (!basicNumberCheck.test(value)) return;
                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                            if (!decimalRegex.test(value)) return;
                            handleServicesChange(index, "serviceLineCost", value);
                        }} />
                        : <>{defaultCurrency?.symbol} <span >
                            {displayData?.service?.length > 0 ? displayData?.service[index]?.service_line_cost?.toLocaleString() : ""}
                        </span></>}
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '2%',
            render: (text, record, index) => {
                if (edit && servicesData.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px", }} className="fetcherDelete-Icon"
                            onClick={() => removeservice(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            width: '2%',
            render: (text, record, index) => {
                if (edit && index === servicesData.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Services"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewSerivce}
                        />
                    );
                }
            },
        }
    ];
    const StaffColumns = [
        {
            title: 'Role Name',
            dataIndex: 'RoleName',
            key: 'RoleName',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ?
                        <Select style={{ width: "100%" }}
                            showSearch optionLabelProp="label"
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                                const usernameElement = option.children.props.children[1].props.children[0];
                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                    const username = String(usernameElement.props.children);
                                    return username.toLowerCase().includes(input.toLowerCase());
                                }
                                return false;
                            }
                            }
                            placeholder="Select Staff Role"
                            name="addStaffRoleId"
                            value={record.addStaffRoleId}
                            onChange={(value, option) => {
                                handleRolesChange(index, 'addStaffRoleId', value, option.name);
                            }}
                        >
                            {staffRoleData.map((option, i) => (
                                <Option value={option.addStaffRoleId} key={i} name={option.country}
                                    label={option.roleName
                                        // (<div style={{ display: 'flex', alignItems: 'center' }} >
                                        //     <div className='Div_flex2'>
                                        //         <div className='share_image' title={`${option.roleName} (${option.country})`} style={{ cursor: "default" }}>
                                        //             <span className="image_icon">
                                        //                 {option.roleName?.slice(0, 1).toUpperCase()}
                                        //             </span>
                                        //             <span className='div-ellipsis'>{option.roleName}</span>
                                        //         </div>
                                        //     </div>
                                        // </div>)
                                    }>
                                    <div className='UserList-dropdown' title={`${option.roleName} (${option.country})`}>
                                        <div>
                                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                {option.roleName?.slice(0, 1).toUpperCase()}
                                            </span>
                                        </div>
                                        <div>
                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.roleName}</p>
                                            <p style={{ margin: 0 }}>({option.country})</p>
                                        </div>
                                    </div>
                                </Option>))}
                        </Select>
                        :
                        <span >
                            {displayData?.staffRoles?.length > 0 ? `${displayData?.staffRoles[index]?.roleName} ${displayData?.staffRoles[index]?.country}` : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: `Per Day Rate (${defaultCurrency?.currency})`,
            dataIndex: 'RolePerDayRate',
            key: 'RolePerDayRate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item>
                    {edit ? <Input placeholder='Role Per Day Rate' pattern="^\d+(\.\d+)?$" min={0}
                        name="rolePerDayRate" prefix={defaultCurrency?.symbol}
                        disabled
                        value={record.rolePerDayRate}
                        onChange={(e) =>
                            handleRolesChange(index, 'rolePerDayRate', e.target.value, record.country)
                        } /> : <>{defaultCurrency?.symbol} <span >
                            {displayData?.staffRoles?.length > 0 ? displayData?.staffRoles[index]?.role_per_day_rate?.toLocaleString() : ""}
                        </span></>}
                </Form.Item>
            ),
        },
        {
            title: 'Start Date',
            dataIndex: 'StartDate',
            key: 'StartDate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ?
                        <DatePicker
                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                            name="startDate"
                            disabledDate={(current) => {
                                const closure = form.getFieldValue("expectedClosureDate");
                                const end = record.endDate ? moment(record.endDate, "YYYY-MM-DD").startOf("day") : null;

                                return current && (
                                    current < moment().startOf("day") ||
                                    (closure && current.isBefore(closure, 'day')) ||
                                    (end && current.isAfter(end, 'day'))
                                );
                            }}
                            placeholder="Select Start Date"
                            onChange={(date, dateString) =>
                                handleRolesChange(index, 'startDate', dateString, record.country)
                            }
                        />
                        :
                        <span >
                            {displayData?.staffRoles?.length > 0 ?
                                displayData?.staffRoles[index]?.start_date ? moment(displayData?.staffRoles[index].start_date).format(profile.dateFormate) : (displayData?.staffRoles[index]?.start_date && moment(displayData?.staffRoles[index].start_date).format("YYYY-MM-DD")) : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: 'End Date',
            dataIndex: 'EndDate',
            key: 'EndDate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ?
                        <>
                            <DatePicker
                                name="endDate"
                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                disabledDate={(current) => {
                                    const start = record.startDate ? moment(record.startDate, "YYYY-MM-DD").startOf("day") : null;
                                    const closure = form.getFieldValue("expectedClosureDate");
                                    return current && (
                                        current < moment().startOf("day") ||
                                        (start && current.isBefore(start, 'day')) ||
                                        (closure && current.isBefore(closure, 'day'))
                                    );
                                }}
                                placeholder="Select End Date"
                                onChange={(date, dateString) =>
                                    handleRolesChange(index, 'endDate', dateString, record.country)
                                }
                            />
                        </>
                        :
                        <span >
                            {displayData?.staffRoles?.length > 0 ?
                                displayData?.staffRoles[index]?.end_date ? moment(displayData?.staffRoles[index].end_date).format(profile.dateFormate) : (displayData?.staffRoles[index]?.end_date && moment(displayData?.staffRoles[index].end_date).format("YYYY-MM-DD")) : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: `Total Value (${defaultCurrency?.currency})`,
            dataIndex: 'TotalValue',
            key: 'TotalValue',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input placeholder='Enter Total Value' disabled prefix={defaultCurrency?.symbol}
                        name="totalValue"
                        value={record.totalValue}
                        onChange={(e) =>
                            handleRolesChange(index, 'totalValue', e.target.value, record.country)
                        } /> : <>{defaultCurrency?.symbol} <span >{displayData?.staffRoles?.length > 0 ? displayData?.staffRoles[index]?.total_value?.toLocaleString() : ""}
                        </span></>}
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            // width: '5%',
            render: (text, record, index) => {
                if (edit && roleData.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            onClick={() => removeRoles(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            // width: '5%',
            render: (text, record, index) => {
                if (edit && index === roleData.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Staff Augmentation"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewRoles}
                        />
                    );
                }
            },
        }
    ];
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead")
        setNaCTrigger("trigger")
        setTaskProp({
            type: pageTypes,
            ids: [id]
        })
    }
    const CreateMail = async (IdDatas) => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            try {
                if (IdDatas.length > 0) {
                    const attendeeData = await Promise.all(
                        IdDatas.map(async (id) => {
                            const res = await fetchAttendeeData(id);
                            return {
                                id: res.contacts_id,
                                type: "Contacts"
                            }
                        })
                    );
                    setNaCTrigger("trigger")
                    setEmailAttendees(attendeeData);
                    setMailOpen(true);
                }
                else {
                    setNaCTrigger("trigger")
                    setEmailAttendees([]);
                    setMailOpen(true);
                }
            } catch (error) {
                message.error(error)
            }
        }
    }
    const CreateMeeting = async (IdDatas) => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            try {
                if (IdDatas.length > 0) {
                    const attendeeData = await Promise.all(
                        IdDatas.map(async (ids) => {
                            const response = await fetchAttendeeData(ids);
                            return {
                                id: ids,
                                name: `${response?.first_name} ${response?.last_name}`,
                                type: "Contacts",
                                email: response?.email
                            };
                        })
                    );
                    setNaCTrigger("trigger")
                    setMeetingAttendees(attendeeData);
                    setMeetingOpen(true);
                }
                else {
                    setMeetingAttendees([]);
                    setMeetingOpen(true);
                }
            } catch (error) {
                message.error(error)
            }
        }
    }
    const OndealvalueChange = (value) => {
        setDealValue(value)
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    dealOwner: profile.userId,
                });
            }
        }
    }
    const fetchAll1 = async () => {
        await Promise.allSettled([
            fetchDropdownOptions(),
        ]);
        setTimeout(() => {
            setUiReady(true);
        }, 1000);
    };
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            handleAccountChange(displayData?.account_id, displayData?.contactPerson),
            UserDetailsApi(),
            getAllAccoutbyType(),
            ProductApi(),
            ServiceLineApi(),
            StaffRoleApi(),
        ])
    };
    const getFetchTwo = async () => {
        await Promise.allSettled([
            getUserDetail(),
            getPriority()
        ])
    };
    const fetchAlld11 = async () => {
        await Promise.allSettled([
            scroolup(),
            fetchCustomGroupsAndFields(),
        ])
    };
    const fetchAlld = async () => {
        await Promise.allSettled([
            getEntityAvalibitlity(),
        ])
    };
    useEffect(() => {
        if (FromPage) {
            fetchAlld11()
        }
    }, [FromPage]);
    useEffect(() => {
        if (FromPage && displayData && customFields) {
            fetchAll1();
        }
    }, [FromPage, displayData, customFields]);
    useEffect(() => {
        if (typeAction === "Staff Augmentation" && FromPage) {
            let minStart = null;
            let maxEnd = null;
            roleData.forEach(role => {
                const { startDate, endDate } = role;
                const parsedStartDate = startDate !== null && startDate !== undefined && startDate !== "" ? startDate : null
                const parsedEndDate = endDate !== null && endDate !== undefined && endDate !== "" ? endDate : null
                if (!minStart || (parsedStartDate && parsedStartDate < minStart)) {
                    minStart = parsedStartDate;
                }
                if (!maxEnd || (parsedEndDate && parsedEndDate > maxEnd)) {
                    maxEnd = parsedEndDate;
                }
            });
            const StartDateFormate = formatDateString(minStart, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const EndDateFormate = formatDateString(maxEnd, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            form.setFieldsValue({
                revenueStartDate: minStart !== null && minStart !== undefined && minStart !== "" ? moment(StartDateFormate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD") : null,
                revenueEndDate: maxEnd !== null && maxEnd !== undefined && maxEnd !== "" ? moment(EndDateFormate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD") : null,
            })
        }
    }, [roleData, FromPage]);
    useEffect(() => {
        if (FromPage) {
            totalCalculation()
        }
    }, [formDatas, servicesData, roleData, winProbability, typeAction, dealValues, dealDiscount, totalDeal, FromPage, changeDealMargin, changeDealMargin2, pipeLineField])
    useEffect(() => {
        if (FromPage && displayData) {
            if (FromPage === "AccountPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId,
                    contactPerson: []
                })
                handleAccountChange(dataForDeal?.AccountId, "")
            }
            else if (FromPage === "ContactPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId,
                    contactPerson: dataForDeal?.contactId
                })
                handleAccountChange(dataForDeal?.AccountId, "")
            }
        }
    }, [FromPage, displayData])
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll();
        }
    }, [FromPage, editField, displayData]);
    useEffect(() => {
        if (pipeLineStage.length) {
            const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
            const currentFromPage = FromPage;
            if (DealprevValues.current.UrlId === currentUrlId && DealprevValues.current.FromPage === currentFromPage) return;
            DealprevValues.current = { UrlId: currentUrlId, FromPage: currentFromPage };
            if (FromPage) {
                if (FromPage === "EntityUpdate") {
                    fetchAlld()
                }
                else {
                    const allValues = form.getFieldsValue(true);
                    const resetTitles = {};
                    Object.keys(allValues).forEach(key => {
                        if (key.startsWith("title-")) {
                            resetTitles[key] = undefined;
                        }
                    });
                    form.setFieldsValue(resetTitles);
                    const formValues = allFieldStructure
                        .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
                        .reduce((acc, item) => {
                            acc[item.fieldKey] =
                                item.fieldType === "Multi-Dropdown" ? [] :
                                    item.fieldType === "CheckBox" ? false : undefined;
                            return acc;
                        }, {});
                    form.setFieldsValue(formValues);
                    setDealInitial({
                        oldPipelineStage: null,
                        staffRole: [],
                        products: [],
                        services: [],
                    })
                    setImages({});
                    setDeleteOptions({});
                    setFileLists({});
                    setDisplayData("Create")
                    setDealId()
                    setStates({ ...states, selectedRowKeys: [] });
                    getFetchTwo()
                    setDataPermissions("Read,Update,Delete,Sharing")
                    setEdit(true)
                    setEditableType(true)
                    setEditField(true)
                }
            }
        }
    }, [UrlId, FromPage, pipeLineStage]);
    useEffect(() => {
        if (allFieldStructure.length) {
            getPipelineStage()
        }
    }, [UrlId, FromPage, allFieldStructure]);
    useEffect(() => {
        if (drawerPage === "CloneDeal") {
            getData(dealId)
            setDataPermissions("Read,Update,Delete,Sharing")
            setEditField(true)
            setEdit(true)
            setEditableType(true)
        }
    }, [drawerPage]);
    const handleEditChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (Role !== "Administrator") {
                if (pipeLineField?.toLowerCase() === "won" || pipeLineField?.toLowerCase() === "lost") {
                    setEditWon(true)
                    setEditField(true)
                    dispatch(setEditCall(true))
                }
                else {
                    setEdit(true)
                    setEditField(true)
                    dispatch(setEditCall(true))
                }
            }
            else {
                setEditField(true)
                setEdit(true)
                dispatch(setEditCall(true))
                handleAccountChange(displayData?.accountId, "");
                handlePipeLineChange(pipeLineStage, displayData?.pipelineStage, tempWinProp, "Update");
                handleDealTypeChange(displayData?.dealType, { children: displayData?.dealTypeName });
                setTrigger("");
                setApproveOpen(false)
            }
        }
    }
    const CloneLead = () => {
        setDrawerPage("CloneDeal")
    }
    const moreAction = "Yes"
    const MoreAction = ({ closeDropdown }) => (
        <div style={{
            padding: "0px 10px",
            width: "100%",
            height: "100%",
        }}>
            <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2014)) ? undefined : () => { CloneLead(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2014)) ? "disabled_link" : ''}`}>
                <CloneIcon height={15} width={15} marginRight={5} /> Clone
            </Link>
            <Link to={combinedUrl} onClick={(edit || (profile.userId !== displayData?.dealOwner)) ?
                undefined : () => { HandleShareClick(); closeDropdown() }}
                className={`text_icon ${(edit || (profile.userId !== displayData?.dealOwner)) ? 'disabled_link' : ""}`}>
                <ShareIcon height={14} width={14} marginRight={5} /> Share
            </Link>
            {/* <Link to={combinedUrl} onClick={(edit || !canShare(dataPermissions, "Sharing")) ? undefined : () => { HandleShareClick(); closeDropdown() }} className={`text_icon ${(edit || !canShare(dataPermissions, "Sharing")) ? 'disabled_link' : ""}`}>
                <ShareIcon height={16} width={16} marginRight={5} /> Share
            </Link> */}
            <Link to={combinedUrl} onClick={!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2015) ? () => { AssignToFucntion(); closeDropdown() } : undefined} className={`text_icon ${canUpdateDelete(permissions, dataPermissions, "Update", 2015) ? "" : 'disabled_link'}`}>
                <ChangeOwnerIcon height={15} width={15} marginRight={5} /> Change Owner
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2014)) ? undefined : () => { handleNoteClick("Create"); closeDropdown() }} className={`text_icon ${(edit || !canCreate(permissions, 2014)) ? "disabled_link" : ''}`}>
                <NotesIcon height={13} width={13} marginRight={5} /> Add a Note
            </Link>
        </div >
    );
    MoreAction.propTypes = {
        closeDropdown: PropTypes.func.isRequired,
    };
    const ButtonActions = [
        {
            Actions: <div className={(!canCreate(permissions, 2014)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Send Email'
                onClick={(!canCreate(permissions, 2014)) ? undefined : () => CreateMail(contactIds)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2014) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMail(contactIds)
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2014)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Schedule a Meeting'
                onClick={(!canCreate(permissions, 2014)) ? undefined : () => CreateMeeting(contactIds)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2014) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMeeting(contactIds)
                    }
                }}
                aria-label='Meeting'
            > <CalendarIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2014)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Create Task'
                onClick={(!canCreate(permissions, 2014)) ? undefined : () => CreateTask(dealId)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2014) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateTask(dealId)
                    }
                }}
                aria-label='task'
            > <TaskIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2014)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Log a Call'
                onClick={(!canCreate(permissions, 2014)) ? undefined : () => handleCallLogClick("Create")}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2014) && (event.key === 'Enter' || event.key === ' ')) {
                        handleCallLogClick("Create")
                    }
                }}
                aria-label='phone'
            > <CallLogIcon height={20} width={20} /></div>
        },
    ]
    const LeadInfos = {
        profile: images.dealProfile ?? null,
        Classname: "DealIcon",
        letterIcon: displayData?.dealName,
        name: displayData?.dealName,
        subName: displayData?.accountOriginalName,
        mainAction: <>
            {(!(pipelineV === "Proposal" && canCreate(permissions, 2014)) || edit) ? undefined :
                <Button className="button_colors" size="small" style={{ width: "60%" }} onClick={() => CreateQuotes(dealId, displayData?.account_id)}>
                    <QuotesIcon height={25} width={25} marginRight={5} />Add Quote
                </Button>}
        </>,
    }
    const validateRows = (rows, requiredFields, entityName = 'Row') => {
        const rowIndex = rows.findIndex(row =>
            requiredFields.some(
                field => row[field] === null || row[field] === undefined || row[field] === ''
            )
        );
        if (rowIndex !== -1) {
            message.error(<span>
                Please complete the missing fields in Row <strong>{rowIndex + 1}</strong> under <strong>{entityName}</strong>
            </span>);
            return false; // stop execution
        }
        return true; // all rows valid
    };
    const hasAnyValue = (item) => {
        return Object.values(item).some(val => val !== null && val !== undefined && val !== '');
    };
    const isEqual = (a, b) => {
        if (a === b) return true;
        // if (typeof a !== typeof b) return false;
        if (
            (typeof a === "number" && typeof b === "string") ||
            (typeof a === "string" && typeof b === "number")
        ) {
            return String(a) === String(b);
        }
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;
            return keysA.every(key => isEqual(a[key], b[key]));
        }
        return false;
    };
    const getChangedFields = (currentStructure, initialStructure) => {
        return currentStructure.filter((currField) => {
            const initField = initialStructure.find((f) => f.fieldId === currField.fieldId);
            if (!initField) return true;
            const currValue = currField.value;
            const initValue = initField.value;
            return !isEqual(currValue, initValue);
        });
    };
    const isEqual1 = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields1 = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual1(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        if (typeAction === "Request for Proposal") {
            if (formDatas.length > 0) {
                const anyValue = formDatas.some(row => hasAnyValue(row));
                if (anyValue) {
                    if (!validateRows(formDatas, ['dealProductId', 'numberOfUnits', 'licenseDuration'], 'Add Products')) return;
                }
            }
            if (servicesData.length > 0) {
                const anyValue = servicesData.some(row => hasAnyValue(row));
                if (anyValue) {
                    if (!validateRows(servicesData, ['serviceName', 'serviceLineId', 'serviceLineCost'], 'Add Services')) return;
                }
            }
        }
        if (typeAction === "Product and Services") {
            const productsHaveData = formDatas.some(hasAnyValue);
            const servicesHaveData = servicesData.some(hasAnyValue);
            if (!productsHaveData && !servicesHaveData) {
                message.error("Please add at least one Product or Service");
                return;
            }
            if (productsHaveData) {
                if (!validateRows(formDatas, ['dealProductId', 'numberOfUnits', 'licenseDuration'], 'Add Products')) return;
            }
            if (servicesHaveData) {
                if (!validateRows(servicesData, ['serviceName', 'serviceLineId', 'serviceLineCost'], 'Add Services')) return;
            }
        }
        if (typeAction === "Staff Augmentation") {
            if (roleData.length > 0) { if (!validateRows(roleData, ['addStaffRoleId', 'country', 'rolePerDayRate', 'startDate', 'endDate', 'totalValue'], 'Add Roles')) return; }
        }
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const currentStructure = await Promise.all(
            allFieldStructure.map(async (field) => {
                let value;
                switch (field.fieldType) {
                    case 'FileUpload':
                        value = normalizeValue(images[field.fieldKey] ?? null);
                        break;
                    case 'MultiFileUpload':
                        value = fileLists[field.fieldKey] || [];
                        break;
                    case 'Date':
                        value = values[field.fieldKey]
                            ? moment(values[field.fieldKey]).format("YYYY-MM-DD")
                            : null;
                        break;
                    case 'Number':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Percentage':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Currency':
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? await convertCurrency(ConvertRate, Number(values[field.fieldKey]))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = values[field.fieldKey] && values[field.fieldKey].length > 0
                            ? values[field.fieldKey].join(",")
                            : null;
                        break;
                    case 'CheckBox':
                        value = values[field.fieldKey] ?? false;
                        break;
                    default:
                        value = normalizeValue(values[field.fieldKey] ?? null);
                        break;
                }
                return { ...field, value };
            })
        );
        const convertedServicesData = await Promise.all(
            servicesData.map(async (service) => {
                const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                    convertCurrency(ConvertRate, Number(service.serviceLineCost))
                    : service.serviceLineCost
                );
                return {
                    ...service,
                    serviceLineCost: convertedCost?.toString(),
                };
            })
        );
        const convertedRoleData = await Promise.all(
            roleData.map(async (role) => {
                const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                    ? convertCurrency(ConvertRate, Number(role.rolePerDayRate))
                    : role.rolePerDayRate);
                const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== "" ?
                    convertCurrency(ConvertRate, Number(role.totalValue))
                    : role.totalValue);
                return {
                    ...role,
                    rolePerDayRate: convertedRate?.toString(),
                    totalValue: convertedTotalValue?.toString(),
                };
            })
        );
        const convertedFormDatas = await Promise.all(
            formDatas.map(async (product) => {
                const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                    ? convertCurrency(ConvertRate, Number(product.productLicenseSellingPriceUnitMonth))
                    : product.productLicenseSellingPriceUnitMonth);
                const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                    ? convertCurrency(ConvertRate, Number(product.total))
                    : product.total);
                return {
                    ...product,
                    productLicenseSellingPriceUnitMonth: convertedPrice?.toString(),
                    total: convertedTotal?.toString(),
                };
            })
        );
        const formData = {
            oldPipelineStage: normalizeValue((pipeLineField?.toLowerCase() === "onhold" || pipeLineField?.toLowerCase() === "lost") ? oldPipeline : null),
        }
        const hasValidData = (obj) =>
            obj && Object.values(obj).some(val => val !== null && val !== undefined && val !== "");
        if (typeAction === "Staff Augmentation") {
            formData.staffRole = convertedRoleData;
            formData.products = [];
            formData.services = [];
        } else if (typeAction === "Product and Services" || typeAction === "Request for Proposal") {
            formData.products = convertedFormDatas.filter(hasValidData);
            formData.services = convertedServicesData.filter(hasValidData);
            formData.staffRole = [];
        } else {
            formData.staffRole = [];
            formData.products = [];
            formData.services = [];
        }
        const updatedFields = getChangedFields1(formData, dealInitial);
        const changedFields = getChangedFields(currentStructure, allFieldStructure);
        const noDefaultChanges = changedFields.length === 0;
        const noExtraChanges = !updatedFields || Object.keys(updatedFields).length === 0;
        if (noDefaultChanges && noExtraChanges) {
            getData(dealId);
            scroolup();
            message.success("Deal updated");
            loadingRef.current = false;
            setDoubleClick(false);
            CloseDrawerNew();
            return;
        }
        const defaultChanges = {};
        const customFieldValues = [];
        changedFields.forEach((field) => {
            if (field.customFieldType === "Default") {
                defaultChanges[field.fieldKey] = field.value;
            } else {
                const obj = {
                    entityId: field.entityId,
                    fieldId: field.fieldId,
                    value: field.value,
                };
                customFieldValues.push(obj);
            }
        });
        const payload = {
            ...defaultChanges,
            ...(customFieldValues.length > 0 && { customFieldValues }),
            ...(updatedFields && Object.keys(updatedFields).length > 0 && updatedFields),
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate" && drawerPage !== "CloneDeal") {
                const response = await DealUpdate(payload, dealId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const ownerChanged = displayData?.dealOwner !== values.dealOwner;
                        if (response.data[0].message === ApprovalMessage) {
                            hideMessage();
                            getData(dealId)
                            scroolup()
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            loadingRef.current = false;
                            setDoubleClick(false)
                            CloseDrawerNew()
                        }
                        else if (ownerChanged) {
                            hideMessage();
                            if (response.data[0].message === AutomationMessage) {
                                if (pipeLineField?.toLowerCase() === "won") {
                                    dispatch(setExPoCall(true));
                                    successMessage("Automation rule triggered", response.data[0].message)
                                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                                } else {
                                    successMessage("Automation rule triggered", response.data[0].message)
                                }
                            }
                            else if (response.data[0].message !== ApprovalMessage && response.data[0].message !== AutomationMessage) {
                                if (pipeLineField?.toLowerCase() === "won") {
                                    dispatch(setExPoCall(true));
                                    successMessage("Deal Won",
                                        <>
                                            <img
                                                src={require('../../../static/img/defaultImages/Won.gif')}
                                                alt="celebration"
                                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                            />
                                            <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                                        </>)
                                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                                } else {
                                    message.success(
                                        <span>
                                            Deal <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                        </span>
                                    );
                                }
                            }
                            else {
                                message.success(
                                    <span>
                                        Deal <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/deals');
                        }
                        else {
                            getData1(dealId, hideMessage, AutomationMessage, ApprovalMessage, response, pipeLineField)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createDeals(payload)
                if (response.status === 201) {
                    hideMessage();
                    if (response?.data === AutomationMessage) {
                        if (ShortCut === "Shortcut" || FromPage === "ContactPage" || FromPage === "AccountPage") {
                            if (pipeLineField?.toLowerCase() === "won") {
                                dispatch(setExPoCall(true))
                                successMessage("Automation rule triggered", response?.data)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            }
                            else if (ShortCut !== "Shortcut" && FromPage !== "AccountPage" && FromPage === "ContactPage") {
                                dispatch(setExPoCall(true))
                                successMessage("Automation rule triggered", response?.data)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            }
                            else {
                                successMessage("Automation rule triggered", response?.data)
                            }
                        }
                        else if (drawerPage === "CloneDeal") {
                            if (pipeLineField?.toLowerCase() === "won") {
                                dispatch(setExPoCall(true));
                                successMessage("Automation rule triggered", response?.data)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            } else {
                                successMessage("Automation rule triggered", response?.data)
                            }
                        }
                        else {
                            const isture = pipeLineField?.toLowerCase() === "won"
                            if (isture) {
                                dispatch(setExPoCall(true));
                                successMessage("Automation rule triggered", response?.data)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            } else {
                                successMessage("Automation rule triggered", response?.data)
                            }
                        }
                    }
                    else if (response?.data === ApprovalMessage) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    }
                    else if (response?.data !== ApprovalMessage && response?.data !== AutomationMessage) {
                        if (ShortCut === "Shortcut" || FromPage === "ContactPage" || FromPage === "AccountPage") {
                            if (pipeLineField?.toLowerCase() === "won") {
                                dispatch(setExPoCall(true))
                                successMessage("Deal Won",
                                    <>
                                        <img
                                            src={require('../../../static/img/defaultImages/Won.gif')}
                                            alt="celebration"
                                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                        />
                                        <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                                    </>)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            }
                            else if (ShortCut !== "Shortcut" && FromPage !== "AccountPage" && FromPage === "ContactPage") {
                                dispatch(setExPoCall(true))
                                successMessage("Deal created",
                                    <>
                                        <img
                                            src={require('../../../static/img/defaultImages/Deal.gif')}
                                            alt="celebration"
                                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                        />
                                        <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                                    </>)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            }
                            else {
                                successMessage("Deal created", <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Deal.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                                </>)
                            }
                        }
                        else if (drawerPage === "CloneDeal") {
                            if (pipeLineField?.toLowerCase() === "won") {
                                dispatch(setExPoCall(true));
                                successMessage("Deal Won",
                                    <>
                                        <img
                                            src={require('../../../static/img/defaultImages/Won.gif')}
                                            alt="celebration"
                                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                        />
                                        <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                                    </>)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            } else {
                                successMessage("Deal created", <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Deal.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                                </>)
                            }
                        }
                        else {
                            const isture = pipeLineField?.toLowerCase() === "won"
                            if (isture) {
                                dispatch(setExPoCall(true));
                                successMessage("Deal Won", <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Won.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                                </>)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            } else {
                                successMessage("Deal created", <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Deal.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                                </>)
                            }
                        }
                    }
                    else {
                        successMessage("Deal created", <>
                            <img
                                src={require('../../../static/img/defaultImages/Deal.gif')}
                                alt="celebration"
                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                            />
                            <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                        </>)
                    }
                    if (FromPage === "AccountPage" || FromPage === "ContactPage") {
                        CallBackTrigger("Callback")
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer()
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const showConfirmForAccount = (values) => {
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Associated Account Change</span>
                </div>
            ),
            icon: null,
            content: (
                <p>You are about to change the associated account for this record. This may affect linked data. Continue?</p>
            ),
            centered: true,
            className: "customice-confirm-modal",
            okText: "No",
            cancelText: "Yes",
            okButtonProps: {
                className: "button_colorsModal"
            },
            cancelButtonProps: {
                className: "gray-buttonModal"
            },
            okCancel: true,
            onOk() {
                modal.destroy();
            },
            onCancel() {
                onSubmit(values)
            },
        });
    };
    const onSubmit1 = async (values) => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            if (values.accountName !== displayData.account_id) {
                showConfirmForAccount(values)
            }
            else {
                onSubmit(values)
            }
        } else {
            onSubmit(values)
        }
    }
    const CloseDrawer2 = () => {
        if (FromPage !== "AccountPage" || FromPage !== "ContactPage") {
            scroolup()
            getData(dealId)
        }
        setEditWon(false);
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
        setDrawerPage()
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            CloseDrawer2()
        }
        else if (FromPage === "EntityUpdate" && drawerPage === "CloneLead") {
            setCancelConfirmOpen(true)
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        CloseDrawer2()
        setTrigger("activity");
    }
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], dealId] : null), [UrlId, dealId]);
    const updatePsqq = useMemo(() => ({ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2015 }), [permissions, dataPermissions]);
    const getDetailsDatas = useCallback(() => getData(dealId), [dealId]);
    const MemoLeadStatusBar = useMemo(() => (
        <DealStatusBar UrlId={memoUrlId} getDetailsData={getDetailsDatas} leadStatusData={pipeLineStage}
            displayData={displayData} setNaCTrigger={setNaCTrigger} canUpdateDelete={canUpdateDelete} allFieldStructure={allFieldStructure}
            UpdatePs={updatePsqq} ApprovalMessage={ApprovalMessage} commitStatusId={commitStatusId}
            AutomationMessage={AutomationMessage} setErrorData={setErrorData}
            customGroups={customGroups}
            customFields={customFields || {}}
            optionsMap={optionsMap}
            setIsModalVisible1={setIsModalVisible1} setTrigger={setTrigger} />
    ), [memoUrlId, getDetailsDatas, displayData, setNaCTrigger, allFieldStructure, customGroups, optionsMap, customFields, commitStatusId, canUpdateDelete, updatePsqq, ApprovalMessage,
        AutomationMessage, setErrorData, setIsModalVisible1, setTrigger, pipeLineStage]);
    const MemoLeadFields = useMemo(() => (
        <DealFields ApprovalMessage={ApprovalMessage} AutomationMessage={AutomationMessage} editWon={editWon} ViewDetailPage={ViewDetailPage} displayData={dealDetailsData}
            defaultCurrency={defaultCurrency} setErrorData={setErrorData} setIsModalVisible1={setIsModalVisible1} overAllDetails={overAllDetails} allFieldStructure={allFieldStructure}
            setTrigger={setTrigger} canUpdateDelete={canUpdateDelete} permissions={permissions} dataPermissions={dataPermissions} getData={getDetailsDatas}
            setNaCTrigger={setNaCTrigger} arrayDisplayData={arrayDisplayData} customFields={customFields} />
    ), [arrayDisplayData, setIsModalVisible1, dealInitial, allFieldStructure, setNaCTrigger, setTrigger, canUpdateDelete, permissions, customFields, overAllDetails,
        dataPermissions, getDetailsDatas, dealDetailsData, ApprovalMessage, AutomationMessage, editWon, ViewDetailPage, defaultCurrency, setErrorData]);
    const MemoRelatedTab = useMemo(() => (
        <RelatedTab EntityType={pageTypes} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} displayData={displayData} trigger={trigger} defaultCurrency={defaultCurrency} />
    ), [memoUrlId, NacTrigger, setNaCTrigger, profile, emailapiValues, trigger, displayData, defaultCurrency]);
    const MemoRightRelatedData = useMemo(() => (
        <DealRightData displayData={displayData} dataDisables={dataDisables} profile={profile} ViewDetailPage={ViewDetailPage}
            UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} defaultCurrency={defaultCurrency} trigger={trigger} />
    ), [displayData, dataDisables, profile, ViewDetailPage, memoUrlId, NacTrigger, setNaCTrigger, trigger, defaultCurrency]);
    const leadSharedProps = useMemo(() => ({
        form, edit, combinedUrl, UrlId, displayData, users, account, dataDisables, setDataDisables, images, setImage, dealId, pipeLineField, pipeLineStage, disabledDate,
        deleteOptions, setDeleteOption, onchangeDelete, handleAccountChange, contacts, dealTypeField, dealMapList, defaultCurrency, dealValueEdit, handleDealTypeChange,
        fileLists, setFileList, pipelineData, handlePipeLineChange, tempWinProp, editableType, oldPipeline, accountbyType, dealFieldConfig, typeAction, handleTypeAction,
        setChangeDealMargin, setWinProbability, setDealDiscount, OndealvalueChange, pageTypes, editWon,
    }), [
        form, edit, combinedUrl, UrlId, displayData, users, account, dataDisables, setDataDisables, images, setImage, dealId, pipeLineField, pipeLineStage, disabledDate,
        deleteOptions, setDeleteOption, onchangeDelete, handleAccountChange, contacts, dealTypeField, dealMapList, defaultCurrency, dealValueEdit, handleDealTypeChange,
        fileLists, setFileList, pipelineData, handlePipeLineChange, tempWinProp, editableType, oldPipeline, accountbyType, dealFieldConfig, typeAction, handleTypeAction,
        setChangeDealMargin, setWinProbability, setDealDiscount, OndealvalueChange, editWon
    ]);
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} canUpdateDelete={canUpdateDelete} entity={pageTypes} editWon={editWon}
                                UpdatePs={updatePsqq} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={ButtonActions} Maincontent={LeadInfos} UpdateDataPage={MemoLeadStatusBar}
                                EntityTabDetails={MemoLeadFields} EntityRelatedTab={MemoRelatedTab} RightRelatedDetails={MemoRightRelatedData} />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={FromPage === "EntityUpdate" ? drawerPage === "CloneDeal" ? "Clone Deal" :
                    <span>
                        Update Deal
                        {displayData?.dealName && (
                            <>
                                <span style={{
                                    margin: '0 10px',
                                    color: '#d9d9d9',
                                    fontWeight: 'normal'
                                }}>|</span>
                                <span style={{ fontWeight: 'normal' }}>
                                    {displayData?.dealName}
                                </span>
                            </>
                        )}
                    </span> : "Create Deal"}
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={<Space>
                    <div className='Hover-Refresh2 back-hover1 able-style'
                        role="button"
                        tabIndex={0} title='Close'
                        onClick={() => PageCancel1()}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                PageCancel1()
                            }
                        }}
                        aria-label='Close'
                    > <CancelIcon width={24} height={24} /></div>
                </Space>}
                footer={(uiReady && edit) ? [
                    <div className="form_action_button">
                        <Button
                            className="gray-button" size="small"
                            onClick={() => PageCancel1()}
                        >
                            <CancelIcon height={25} width={25} />Cancel
                        </Button>
                        {FromPage === "EntityUpdate" && drawerPage !== "CloneDeal" ?
                            (pipelineV === "Won" && typeAction !== "Staff Augmentation") && editWon ? "" :
                                <Button disabled={!canUpdateDelete(permissions, dataPermissions, "Delete", 2016) || deleteClick || doubleClick} loading={deleteClick}
                                    className="red-button" size="small"
                                    onClick={() => deleteMenu(dealId)}
                                >
                                    {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                                </Button> : <></>}
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={deleteClick || doubleClick} loading={doubleClick}>
                            {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneDeal" ? "Update" : "Save"}
                        </Button>
                    </div>] : false}>
                {(uiReady && displayData) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={(values) => onSubmit1(values)} onFinishFailed={onFinishFailed} colon={false} >
                                <BasicFormWrapper>
                                    <VerticalFormStyleWrap>
                                        <div className="add-product-block">
                                            <div style={{ margin: 40 }}>
                                                <Row gutter={15}>
                                                    <Col xs={24}>
                                                        <div className="add-product-content">
                                                            <CommonFormFields
                                                                groups={customGroups}
                                                                customFields={customFields || {}}
                                                                specialFields={LEAD_SPECIAL_FIELDS}
                                                                sharedProps={leadSharedProps}
                                                                optionsMap={optionsMap}
                                                                combinedUrl={combinedUrl}
                                                                moduleIcon="DealIcon"
                                                                moduleLetter={displayData?.dealName?.slice(0, 1)?.toUpperCase() || 'D'}
                                                            />
                                                            {typeAction === "Staff Augmentation" ? <>
                                                                {(roleData.length > 0 || edit) &&
                                                                    <div style={{ display: 'flex' }}>
                                                                        <Heading as="h5">{!edit ? "Role Details" : "Add Roles"}</Heading>
                                                                        {/* {roleData.length === 0 && (revenueStartDate === null || revenueEndDate == null) && <span style={{ color: "red", margin: "1px 10px 0px" }}>* Please, Add Roles for Revenue start and End Date</span>} */}
                                                                    </div>}
                                                                {roleData.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Deal-RoleTable'}`}>
                                                                                <Table
                                                                                    dataSource={roleData}
                                                                                    columns={StaffColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : <Row >{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Staff Augmentation"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewRoles}
                                                                        />} </Row>}
                                                            </> : <></>}
                                                            {typeAction === "Product and Services" || typeAction === "Request for Proposal" ? <>
                                                                {(formDatas.length > 0 || edit) && <Heading as="h5">{!edit ? "Product Details" : "Add Products"}</Heading>}
                                                                {formDatas.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Product-DealTable'}`}>
                                                                                <Table
                                                                                    dataSource={formDatas}
                                                                                    columns={ProductColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : <Row >{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Product"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewRow}
                                                                        />} </Row>}
                                                            </> : <></>}
                                                            {typeAction === "Product and Services" || typeAction === "Request for Proposal" ? <>
                                                                {(servicesData.length > 0 || edit) && <Heading as="h5">{!edit ? "Service Details" : "Add Services"}</Heading>}
                                                                {servicesData.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Service-DealTable'}`}>
                                                                                <Table
                                                                                    dataSource={servicesData}
                                                                                    columns={ServicesColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    : <Row>{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Services"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewSerivce}
                                                                        />}</Row>}
                                                            </> : <></>}
                                                            {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL" && drawerPage !== "CloneDeal") && <>
                                                                <Heading as="h5">Other Information</Heading>
                                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Created Date" >
                                                                            <span >{displayData?.created_at}</span>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Created By" >
                                                                            <UploadUserTag record={{
                                                                                uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                                uploadedById: displayData?.created_by,
                                                                                uploadedProfile: displayData?.createdByProfilePic
                                                                            }} />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Modified Date" >
                                                                            <span >{displayData?.modified_at}</span>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Modified By" >
                                                                            <UploadUserTag record={{
                                                                                uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                                uploadedById: displayData?.modified_by,
                                                                                uploadedProfile: displayData?.modifiedByProfilePic
                                                                            }} />
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row >
                                                            </>}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </VerticalFormStyleWrap>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type={pageTypes} getCallBack={getRefreshtheTable} />}
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            <QuotesAdd UrlId={undefined} FromPage={createPageQuote} setCratePage={setCratePageQuote} dataForDeal={dataForQuote} CallBackTrigger={setNaCTrigger} />
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Deals" entity="EntityPages" toId={emailAttendees} AccountId={displayData?.account_id} CallBackTrigger={setNaCTrigger} entityUId={dealId} />
            {approveOpen && <Approvaldialog confirmPopup={approveOpen} setConfirmPopup={setApproveOpen} />}
            {sharePopup && <SharePopup sharePopup={sharePopup} setSharePopup={setSharePopup} sharingType={pageTypes} sharingIds={[dealId]} PageTypes="Single" />}
            {updatePopup && <Popup updatePopup={updatePopup} setUpdatePopup={setUpdatePopup} dealIDs={dealIDs} GetAll={getDetailsDatas} popupType={popupType} action={action} assignOwner={assignOwner} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} page={page} />}
            {callLogPopup && <CallLogPopup setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            <MeetingLiPopup meetingOpen={meetingOpen} setMeetingOpen={setMeetingOpen} GetAll={getDetailsDatas} taskPage={taskPage} setNaCTrigger={setNaCTrigger} popupPageType="Create" meetingDate={formattedDate} meetingTime={formattedTime} Attendees={meetingAttendees} />
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    ShortCut: PropTypes.string.isRequired,
    dataForDeal: PropTypes.object.isRequired,
    CallBackTrigger: PropTypes.func.isRequired,
};
export default AddNew;